import { createSelector } from 'reselect';
import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
import { getPreviewViewportWidth, getPreviewIframeLeftOffset, getHighlightedWidgetId, getHighlightedWidgetContainerId } from 'ContentEditorUI/redux/selectors/inpageSelectors';
import { getSelectedItemId, getSelectedContainerId, getIsAnythingSelected } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import { getHasAnyFlexColumns, getHasAnyLayoutSections, getAllLayoutSectionTreesAsMap, getHasAnyLockedLayoutSections, getAllGridLayoutTreesAsMap, getIsEditingGridLayouts } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getIsModuleIdInAdvancedModuleIdsWithoutAccessMap, getAdvancedModuleWithoutAccessInfo, getIsModuleIdInPaymentsModulesWithoutAccessSet, getIsModuleInPersonalizationTokensWithoutAccessMap, getIsMissingAccessToSomeAdvancedModule
// @ts-ignore not typed yet
} from 'ContentEditorUI/redux/selectors/downgradeSelectors';
import { getIsTemplateAuthorMode } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { getScrollToNodePositionId } from 'ContentEditorUI/redux/selectors/inpageSelectors';
import { resizeHandleTypes, dropTargetLocations, ROW_DRAG_HANDLE, COLUMN_DRAG_HANDLE, MODULE_DRAG_HANDLE, EMPTY_CONTAINER_DRAG_HANDLE, TOPMOST_SECTION_ROW_DRAG_HANDLE, INSERT_NEW_SECTION_HANDLE, TABLE_DRAG_HANDLE, FLEX_COLUMN_MODULES_CONFIG, GLOBAL_GROUPS_CONFIG, GLOBAL_PARTIALS_CONFIG, HEADER_INFO_CONFIG, FOOTER_INFO_CONFIG, NESTED_MODULES_IN_RTE_CONFIG, POST_BODY_MODULES_CONFIG, GRID_LAYOUTS_NODE_POSITION_CONFIG, dropTypes, HORIZONTAL_STACK_DRAG_HANDLE, VERTICAL_STACK_DRAG_HANDLE } from 'InpageEditorUI/lib/layoutSection/constants';
import { getPositionInfoForResizeHandle, isResizeHandleType } from 'InpageEditorUI/lib/layoutSection/resizeHandleHelpers';
// @ts-ignore not typed yet
import { arrangeNodePositionsById } from 'layout-dnd-utils/nodePositions/nodePositionUtils';
import { EDGE_TOOLBAR_HEIGHT, PINNED_TOOLBAR_HEIGHT, ROUNDED_BUTTON_HEIGHT, RESPONSIVE_SIZES } from 'layout-dnd-components/js/DndToolbar/constants';
import { getIsInNonDefaultBreakpointMode } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { TOP, BEFORE, AFTER } from 'layout-dnd-utils/js/constants';
import { SHADE_BELOW, SHADE_ABOVE, SHADE_BOTH, SHADE_RIGHT, SHADE_LEFT } from 'layout-dnd-components/InsertDropTargets';
import { NUMBER_DND_AREA_TOOLBAR_TYPES, TOOLBAR_TYPES, getDragHandleByType, findAppropriateToolbarSize, adjustResponsiveToolbarToStayInViewPort, SELECTED_TOOLBAR_OFFSET, shouldShowEditModuleOnSelected } from 'InpageEditorUI/lib/toolbarUtils';
import { LAYOUT_SECTIONS_CONFIG, ALL_NODE_POSITION_CONFIG_KEYS, STATIC_MODULES_CONFIG } from 'InpageEditorUI/lib/layoutSection/constants';
import { getIsInLegacyLayoutMode } from 'ContentEditorUI/redux/selectors/inpageSelectors';
import { getHasPaymentsReadAccess, getHasPersonalizationAccess } from 'ContentEditorUI/redux/selectors/authSelectors';
// @ts-ignore not typed yet
import { getNodePositionConfig } from 'InpageEditorUI/redux/selectors/nodePositionConfigSelectors';
import { getHasTheme } from 'ContentEditorUI/redux/selectors/themeSelectors';
// @ts-ignore not typed yet
import { getFeatureFlag } from 'ContentEditorUI/redux/selectors/featureFlagsSelectors';
// @ts-ignore not typed yet
import { getHideAddSectionButton } from 'ContentEditorUI/redux/selectors/featureFlagsSelectors';
import { FEATURE_FLAGS } from 'ContentEditorUI/redux/constants';
import { getIsPatagoniaSidebarCollapsed } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { getIsDataAuthoringModeActive } from 'ContentEditorUI/redux/selectors/instanceEditingSelectors';
import get from 'hs-lodash/get';
import { getHasSectionsLibraryAccess } from 'ContentEditorUI/redux/selectors/sectionsSelectors';
import { iterateFrom } from 'layout-data-lib/GridLayoutDataTree/utils';
import { layoutNodeTypes } from 'layout-dnd-utils/constants/dndAreaHoverPositionConstants';
import { getDropTargetInfo } from 'layout-dnd-utils/dropTargets/calculateGridLayoutTreeDropTargetInfo';
import { SECTION_DRAG_HANDLE } from 'layout-dnd-utils/constants/dnd';
function adjustLeftToAvoidAddSectionButton(childPosition, actionToolbarWidth, parentPos, isInNonDefaultBreakpointMode, measuredWidthsOfInsertNewSectionHandleSizes) {
  let left = childPosition.left + (childPosition.width - actionToolbarWidth) / 2;
  const isNearParentTop = parentPos && childPosition.top - EDGE_TOOLBAR_HEIGHT < parentPos.top + ROUNDED_BUTTON_HEIGHT / 2;
  if (!isInNonDefaultBreakpointMode && isNearParentTop) {
    const btnSize = findAppropriateToolbarSize(measuredWidthsOfInsertNewSectionHandleSizes, parentPos.width);
    const btnHalfWidth = (measuredWidthsOfInsertNewSectionHandleSizes[btnSize] || 0) / 2;
    const btnCenter = parentPos.left + parentPos.width / 2;
    const toolbarRight = left + actionToolbarWidth;
    const btnLeftEdge = btnCenter - btnHalfWidth;
    const btnRightEdge = btnCenter + btnHalfWidth;
    const hasHorizontalOverlap = toolbarRight > btnLeftEdge && left < btnRightEdge;
    if (hasHorizontalOverlap) {
      left = Math.max(childPosition.left, btnLeftEdge - actionToolbarWidth - 8);
    }
  }
  return left;
}
const MAX_TREE_WALK_ITERATIONS = 10;
function findTopmostRowPosition(startPos, nodePositions) {
  var _current;
  let current = startPos;
  let iterations = 0;
  while (current && !current.isTopMostRow && current.parentId && nodePositions && iterations < MAX_TREE_WALK_ITERATIONS) {
    current = nodePositions[current.parentId];
    iterations++;
  }
  return (_current = current) !== null && _current !== void 0 && _current.isTopMostRow ? current : undefined;
}
const childIdsFromNode = (tree, nodeId) => {
  if (!tree) return [];
  const cellOrRow = tree.hasRow(nodeId) ? tree.findRow(nodeId) : tree.hasCell(nodeId) && tree.findCell(nodeId);
  if (!cellOrRow) return [];
  return cellOrRow.isRow() ? cellOrRow.getColumnNames() : cellOrRow.getRowNames();
};
const getLayoutSectionDndState = basicSelector(state => state.layoutSectionDnd);
const getAppStatusState = basicSelector(state => state.appStatus);
export const getIsTrellisTheme = createSelector(getAppStatusState, appStatus => appStatus.isTrellisTheme);
const createLayoutSectionDndSelector = field => {
  return createSelector([getLayoutSectionDndState], state => state[field]);
};
export const getCurrentDragItem = createLayoutSectionDndSelector('currentDragItem');
export const getDragItemIsHidden = createSelector([getCurrentDragItem], currentDragItem => {
  var _ref;
  return (_ref = !!currentDragItem && currentDragItem.hidden) !== null && _ref !== void 0 ? _ref : false;
});
export const getIsMouseInIFrame = createLayoutSectionDndSelector('mouseIsInIFrame');
export const getCurrentDropTarget = createLayoutSectionDndSelector('currentDropTarget');
const getHoveredPositionsDeepestFirst = createLayoutSectionDndSelector('hoveredPositionsDeepestFirst');
export const getMouseCoordsAtDrop = createLayoutSectionDndSelector('mouseCoordsAtDrop');
export const getNodePositions = createLayoutSectionDndSelector('nodePositions');
export const getNodePositionsNeedUpdate = createLayoutSectionDndSelector('nodePositionsNeedUpdate');
export const getHoverPositionsFrozen = createLayoutSectionDndSelector('hoverPositionsFrozen');
export const getBodyOffset = createLayoutSectionDndSelector('bodyOffset');
const getScrollPosition = createLayoutSectionDndSelector('scrollPosition');
export const getScrollLeftPosition = createSelector(getScrollPosition, scrollPosition => {
  var _scrollPosition$left;
  return (_scrollPosition$left = scrollPosition.left) !== null && _scrollPosition$left !== void 0 ? _scrollPosition$left : 0;
});
export const getScrollTopPosition = createSelector(getScrollPosition, scrollPosition => {
  var _scrollPosition$top;
  return (_scrollPosition$top = scrollPosition.top) !== null && _scrollPosition$top !== void 0 ? _scrollPosition$top : 0;
});
export const getNodePositionsBeforeTreeChange = createLayoutSectionDndSelector('nodePositionsBeforeTreeChange');
const getRawDragHandles = createLayoutSectionDndSelector('currentDragHandles');
export const getCanDragLayouts = createSelector([getIsTemplateAuthorMode, getHasAnyLockedLayoutSections], (isTemplateAuthorMode, hasAnyLockedLayoutSections) => {
  // Template authors can always drag layouts
  if (isTemplateAuthorMode) return true;

  // Non-template authors can only drag layouts if no layout sections are locked
  return !hasAnyLockedLayoutSections;
});
export const getNodePositionsByConfigAndId = createSelector(getNodePositions, getNodePositionConfig, (nodePositions, nodePositionsConfig) => {
  return arrangeNodePositionsById(nodePositions, nodePositionsConfig);
});
const getNodePositionsBeforeTreeChangeByConfigAndId = createSelector(getNodePositionsBeforeTreeChange, getNodePositionConfig, (nodePositionsBeforeTreeChange, nodePositionsConfig) => {
  return arrangeNodePositionsById(nodePositionsBeforeTreeChange, nodePositionsConfig);
});
const findNodePositionForLookupId = (nodePositionsByConfigAndId, lookupId, containerLookupId) => {
  if (!lookupId) {
    return undefined;
  }
  for (const configKey of ALL_NODE_POSITION_CONFIG_KEYS) {
    let positionsById = nodePositionsByConfigAndId[configKey];
    if (containerLookupId && positionsById &&
    // Edge case for static section modules, which have parents, but are treated as static module
    positionsById[containerLookupId]) {
      // @ts-ignore TODO: Clean up node position types
      positionsById = positionsById[containerLookupId];
    }
    if (positionsById && Object.prototype.hasOwnProperty.call(positionsById, lookupId)) {
      // @ts-ignore TODO: Clean up node position types
      return positionsById[lookupId];
    }
  }
  return undefined;
};
const findNodePositionFor = (nodePositionsByConfigAndId, hoverPositionOrHandle) => {
  if (!hoverPositionOrHandle) {
    return undefined;
  }
  const lookupId = hoverPositionOrHandle.uniquePositionId || hoverPositionOrHandle.id;
  const containerLookupId = hoverPositionOrHandle.layoutSectionId || hoverPositionOrHandle.gridLayoutId;
  return findNodePositionForLookupId(nodePositionsByConfigAndId, lookupId, containerLookupId);
};
export const getNodePositionsByTreeId = createSelector(getNodePositionsByConfigAndId, nodePositionsByConfigAndId => {
  return Object.assign({}, nodePositionsByConfigAndId[LAYOUT_SECTIONS_CONFIG], nodePositionsByConfigAndId[GRID_LAYOUTS_NODE_POSITION_CONFIG]);
});
export const getNodePositionsByStaticModuleId = createSelector(getNodePositionsByConfigAndId, nodePositionsByConfigAndId => nodePositionsByConfigAndId[STATIC_MODULES_CONFIG]);
export const getNodePositionsBeforeTreeChangeByTreeId = createSelector(getNodePositionsBeforeTreeChangeByConfigAndId, nodePositionsBeforeTreeChangeByConfigAndId => {
  return nodePositionsBeforeTreeChangeByConfigAndId[LAYOUT_SECTIONS_CONFIG];
});
export const getTargetedOrNearbyLayoutSectionId = createLayoutSectionDndSelector('targetedLayoutSectionId');
export const getTargetedLayoutSectionId = createSelector([getTargetedOrNearbyLayoutSectionId, getHoveredPositionsDeepestFirst], (layoutSectionId, hoveredPositions) => {
  const targetedLayoutSection = hoveredPositions.at(-1);
  if (targetedLayoutSection && targetedLayoutSection.inBufferZone) {
    return null;
  }
  return layoutSectionId;
});
export const getTargetedGridLayoutId = createSelector([getTargetedOrNearbyLayoutSectionId, getHoveredPositionsDeepestFirst], (gridLayoutId, hoveredPositions) => {
  const targetedGridLayout = hoveredPositions.at(-1);
  if (targetedGridLayout && targetedGridLayout.inBufferZone) {
    return null;
  }
  return gridLayoutId;
});

// https://issues.hubspotcentral.com/browse/CG-40993
// Only use targetedLayoutSectionId if it exists, and nothing is selected.
const getTargetedLayoutSectionIdIfNothingIsSelected = createSelector([getTargetedLayoutSectionId, getIsAnythingSelected], (targetedLayoutSectionId, isAnythingSelected) => {
  if (!isAnythingSelected && targetedLayoutSectionId) {
    return targetedLayoutSectionId;
  }
  return null;
});
export const getTargetedGridLayoutIdIfNothingIsSelected = createSelector([getTargetedGridLayoutId, getIsAnythingSelected], (targetedGridLayoutId, isAnythingSelected) => {
  if (!isAnythingSelected && targetedGridLayoutId) {
    return targetedGridLayoutId;
  }
  return null;
});
export const getTargetedOrNearbyDndAreaNodePositionsById = createSelector([getNodePositionsByTreeId, getTargetedOrNearbyLayoutSectionId], (nodePositionsByTreeId, targetedLayoutSectionId) => {
  return nodePositionsByTreeId ? nodePositionsByTreeId[targetedLayoutSectionId] : undefined;
});
export const getTargetedDndAreaNodePositionsById = createSelector([getNodePositionsByTreeId, getTargetedLayoutSectionId], (nodePositionsByTreeId, targetedLayoutSectionId) => {
  return nodePositionsByTreeId ? nodePositionsByTreeId[targetedLayoutSectionId] : undefined;
});
export const getTargetedTree = createSelector([getTargetedOrNearbyLayoutSectionId, getAllLayoutSectionTreesAsMap], (targetedLayoutSectionId, allLayoutSectionTreesAsMap) => {
  return allLayoutSectionTreesAsMap[targetedLayoutSectionId];
});
export const getTargetedGridTree = createSelector([getTargetedOrNearbyLayoutSectionId, getAllGridLayoutTreesAsMap], (targetedGridLayoutId, allGridLayoutTreesAsMap) => {
  return allGridLayoutTreesAsMap[targetedGridLayoutId];
});
export const getHoveredSubTree = createSelector([getSelectedItemId, getAllLayoutSectionTreesAsMap], (selectedItemId, allLayoutSectionTreesAsMap) => {
  return allLayoutSectionTreesAsMap[selectedItemId];
});
export const getHoveredDragHandleType = createLayoutSectionDndSelector('hoveredDragHandleType');
const getCurrentColumnResizeHandles = createLayoutSectionDndSelector('currentColumnResizeHandles');
export const getHasInsertNewSectionHandleHovered = createSelector(getHoveredDragHandleType, hoveredDragHandleType => {
  const isHoveringInsertNewSectionHandle = hoveredDragHandleType === INSERT_NEW_SECTION_HANDLE;
  const hideAddSectionButton = getHideAddSectionButton();
  return isHoveringInsertNewSectionHandle && !hideAddSectionButton;
});
const getDeepestHoveredItem = createSelector([getHoveredPositionsDeepestFirst], hoveredPositionsDeepestFirst => {
  var _hoveredPositionsDeep;
  return (_hoveredPositionsDeep = hoveredPositionsDeepestFirst.at(0)) !== null && _hoveredPositionsDeep !== void 0 ? _hoveredPositionsDeep : null;
});
const getSecondToLastHoveredItem = createSelector([getHoveredPositionsDeepestFirst], hoveredPositionsDeepestFirst => {
  var _hoveredPositionsDeep2;
  if (hoveredPositionsDeepestFirst.length < 2) {
    return null;
  }
  return (_hoveredPositionsDeep2 = hoveredPositionsDeepestFirst.at(hoveredPositionsDeepestFirst.length - 2)) !== null && _hoveredPositionsDeep2 !== void 0 ? _hoveredPositionsDeep2 : null;
});
const getHoveredSectionId = createSelector(getSecondToLastHoveredItem, secondToLastHoveredItem => {
  return secondToLastHoveredItem ? secondToLastHoveredItem.id : undefined;
});
export const getIsAnythingDragging = createSelector(getCurrentDragItem, currentDragItem => !!currentDragItem);
export const getShouldShowGridAndToolbars = createSelector(getIsMouseInIFrame, getHoverPositionsFrozen, getIsInLegacyLayoutMode, (mouseIsInIFrame, hoverPositionsFrozen,
// Don't show grid, overlays, and toolbars if in flex column layout mode
isInLegacyLayoutMode) => (mouseIsInIFrame || hoverPositionsFrozen) && !isInLegacyLayoutMode);

// Similar to getShouldShowGridAndToolbars, but also always show gride whenever dragging
export const getShouldShowGrid = createSelector(getIsInLegacyLayoutMode, getIsAnythingDragging, getHasInsertNewSectionHandleHovered, getIsDataAuthoringModeActive, (
// Don't show grid, overlays, and toolbars if in flex column layout mode
isInLegacyLayoutMode, isAnythingDragging, isInsertNewSectionHandleHovered, isDataAuthoringModeActive) => {
  return isAnythingDragging || !isInLegacyLayoutMode && !isInsertNewSectionHandleHovered && !isDataAuthoringModeActive;
});
export const getHoveredResizeHandleType = createSelector(getHoveredDragHandleType, hoveredDragHandleType => {
  if (hoveredDragHandleType && isResizeHandleType(hoveredDragHandleType)) {
    return hoveredDragHandleType;
  }
  return null;
});
export const getIsAnyResizeHandleHovered = createSelector(getHoveredDragHandleType, hoveredDragHandleType => !!hoveredDragHandleType && isResizeHandleType(hoveredDragHandleType));
const getIsDraggingResizeHandle = createSelector(getIsAnythingDragging, getIsAnyResizeHandleHovered, (isAnythingDragging, isResizeHandleHovered) => isAnythingDragging && isResizeHandleHovered);
export const getCurrentColumnInsertTargetInfo = createSelector(getCurrentDropTarget, getTargetedOrNearbyDndAreaNodePositionsById, (dropTarget, targetedDndAreaNodePositionsById) => {
  if (dropTarget && targetedDndAreaNodePositionsById) {
    const type = dropTarget.type;
    let shade;
    if (type === dropTypes.INSERT_COLUMN_BEFORE) {
      const currentColumnPosition = targetedDndAreaNodePositionsById[dropTarget.id];
      const isSingleModuleWrappedInSection = currentColumnPosition.depth === 2;
      const previousColumnId = dropTarget.previousColumnId;
      const previousColumnPosition = targetedDndAreaNodePositionsById[previousColumnId] || {
        top: currentColumnPosition.top,
        height: currentColumnPosition.height,
        right: currentColumnPosition.left
      };

      // TODO [RR]: Enhance dropTarget data to include module/column type so we don't need to split.
      const isBetweenItems = !!(dropTarget.nextColumnId || dropTarget.previousColumnId);
      const dropType = dropTarget.id && dropTarget.id.split('_')[0];
      if (isBetweenItems || dropType === 'cell' || isSingleModuleWrappedInSection) {
        shade = SHADE_BOTH;
      } else {
        shade = SHADE_RIGHT;
      }
      return {
        type: dropTargetLocations.BEFORE,
        top: Math.min(previousColumnPosition.top, currentColumnPosition.top),
        height: Math.max(previousColumnPosition.height, currentColumnPosition.height),
        left: (previousColumnPosition.right + currentColumnPosition.left) / 2,
        shade
      };
    } else if (type === dropTypes.INSERT_COLUMN_AFTER) {
      const currentColumnPosition = targetedDndAreaNodePositionsById[dropTarget.id];
      const isSingleModuleWrappedInSection = currentColumnPosition.depth === 2;
      const nextColumnId = dropTarget.nextColumnId;
      const nextColumnPosition = targetedDndAreaNodePositionsById[nextColumnId] || {
        top: currentColumnPosition.top,
        height: currentColumnPosition.height,
        left: currentColumnPosition.right
      };

      // TODO [RR]: Enhance dropTarget data to include module/column type so we don't need to split.
      const isBetweenItems = !!(dropTarget.nextColumnId || dropTarget.previousColumnId);
      const dropType = dropTarget.id && dropTarget.id.split('_')[0];
      if (isBetweenItems || dropType === 'cell' || isSingleModuleWrappedInSection) {
        shade = SHADE_BOTH;
      } else {
        shade = SHADE_LEFT;
      }
      return {
        type: dropTargetLocations.AFTER,
        top: Math.min(nextColumnPosition.top, currentColumnPosition.top),
        height: Math.max(nextColumnPosition.height, currentColumnPosition.height),
        left: (nextColumnPosition.left + currentColumnPosition.right) / 2,
        shade
      };
    } else if (type === dropTypes.PREPEND_ROW) {
      const currentColumnPosition = targetedDndAreaNodePositionsById[dropTarget.id];
      return {
        type: dropTargetLocations.SPLIT_ROW_BEFORE,
        left: currentColumnPosition.left,
        width: currentColumnPosition.width,
        top: currentColumnPosition.top,
        shade: SHADE_BELOW
      };
    } else if (type === dropTypes.APPEND_ROW) {
      const currentColumnPosition = targetedDndAreaNodePositionsById[dropTarget.id];
      return {
        type: dropTargetLocations.SPLIT_ROW_AFTER,
        left: currentColumnPosition.left,
        width: currentColumnPosition.width,
        top: currentColumnPosition.bottom,
        shade: SHADE_ABOVE
      };
    }
  }
  return null;
});
export const getCurrentRowInsertTargetInfo = createSelector(getCurrentDropTarget, getTargetedOrNearbyDndAreaNodePositionsById, (dropTarget, targetedDndAreaNodePositionsById) => {
  if (dropTarget && targetedDndAreaNodePositionsById) {
    const type = dropTarget.type;
    let shade;
    if (type === dropTypes.INSERT_ROW_BEFORE) {
      const currentRowPosition = targetedDndAreaNodePositionsById[dropTarget.id];
      const previousRowPosition = targetedDndAreaNodePositionsById[dropTarget.previousRowId] || {
        left: currentRowPosition.left,
        width: currentRowPosition.width,
        bottom: currentRowPosition.top
      };

      // TODO [RR]: Enhance dropTarget data to include module/column type so we don't need to split.
      const parentColumnType = dropTarget.parentColumnId && dropTarget.parentColumnId.split('_')[0];
      const isBetweenItems = !!(dropTarget.nextRowId || dropTarget.previousRowId);
      if (isBetweenItems || parentColumnType === 'module') {
        shade = SHADE_BOTH;
      } else if (parentColumnType === 'cell') {
        shade = SHADE_BELOW;
      }
      return {
        type: dropTargetLocations.BEFORE,
        left: Math.min(previousRowPosition.left, currentRowPosition.left),
        width: Math.max(previousRowPosition.width, currentRowPosition.width),
        top: (previousRowPosition.bottom + currentRowPosition.top) / 2,
        previousRowId: dropTarget.previousRowId,
        shade
      };
    } else if (type === dropTypes.INSERT_ROW_AFTER) {
      const currentRowPosition = targetedDndAreaNodePositionsById[dropTarget.id];
      const nextRowPosition = targetedDndAreaNodePositionsById[dropTarget.nextRowId] || {
        left: currentRowPosition.left,
        width: currentRowPosition.width,
        top: currentRowPosition.bottom
      };

      // TODO [RR]: Enhance dropTarget data to include module/column type so we don't need to split.
      const parentColumnType = dropTarget.parentColumnId && dropTarget.parentColumnId.split('_')[0];
      const isBetweenItems = !!(dropTarget.nextRowId || dropTarget.previousRowId);
      if (isBetweenItems || parentColumnType === 'module') {
        shade = SHADE_BOTH;
      } else if (parentColumnType === 'cell') {
        shade = SHADE_ABOVE;
      }
      return {
        type: dropTargetLocations.AFTER,
        left: Math.min(nextRowPosition.left, currentRowPosition.left),
        width: Math.max(nextRowPosition.width, currentRowPosition.width),
        top: (nextRowPosition.top + currentRowPosition.bottom) / 2,
        nextRowId: dropTarget.nextRowId,
        shade
      };
    }
  }
  return null;
});
export const getCurrentGridLayoutDropTargetInfo = createSelector([getCurrentDropTarget, getTargetedOrNearbyDndAreaNodePositionsById, getIsEditingGridLayouts], (dropTarget, targetedDndAreaNodePositionsById, isEditingGridLayout) => {
  if (dropTarget && targetedDndAreaNodePositionsById && isEditingGridLayout) {
    // We're casting these types so they play nicely with the centralized
    // types in layout-dnd-util. This util works in editor 2.0 without having
    // to factor in our exclusiveOr types.
    return getDropTargetInfo(dropTarget, targetedDndAreaNodePositionsById);
  }
  return null;
});
export const getDeepestHoveredNodePositionInfo = createSelector(getDeepestHoveredItem, getNodePositionsByConfigAndId, (deepestItem, nodePositionsByConfigAndId) => {
  if (nodePositionsByConfigAndId && deepestItem) {
    return findNodePositionFor(nodePositionsByConfigAndId, deepestItem);
  }
  return undefined;
});
export const getHoveredNodeInfoDeepestFirst = createSelector(getHoveredPositionsDeepestFirst, getNodePositionsByConfigAndId, (hoveredPositionsDeepestFirst, nodePositionsByConfigAndId) => {
  if (Object.keys(nodePositionsByConfigAndId).length > 0) {
    return hoveredPositionsDeepestFirst.map(hoverPosition => findNodePositionFor(nodePositionsByConfigAndId, hoverPosition));
  }
  return [];
});
export const getTopMostRowNodeInfo = createSelector(getHoveredNodeInfoDeepestFirst, hoveredNodeInfoDeepestFirst => {
  for (const nodeInfo of hoveredNodeInfoDeepestFirst) {
    if (nodeInfo && nodeInfo.depth === 1) {
      return nodeInfo;
    }
  }
  return undefined;
});
const getCurrentDragHandles = createSelector([getRawDragHandles, getHoveredDragHandleType, getCanDragLayouts], (rawDragHandles, hoveredDragHandleType, canDragLayouts) => {
  if (!rawDragHandles) {
    return rawDragHandles;
  }

  // If user cannot drag layouts, return empty array
  const filteredDragHandles = canDragLayouts ? rawDragHandles : [];
  if (hoveredDragHandleType && filteredDragHandles) {
    const hoveredHandleIndex = filteredDragHandles.findIndex(handle => handle.type === hoveredDragHandleType);
    if (hoveredHandleIndex > 0) {
      return filteredDragHandles.slice(hoveredHandleIndex);
    }
  }
  return filteredDragHandles;
});
const getCurrentHoveredDragHandle = createSelector(getCurrentDragHandles, getHoveredDragHandleType, (currentDragHandles, hoveredDragHandleType) => {
  if (!currentDragHandles) {
    return null;
  }
  for (const handle of currentDragHandles) {
    if (handle.type === hoveredDragHandleType) {
      return handle;
    }
  }
  return null;
});

// In "showDndGridWhileSelected" UX we are:
//  - All D&D grid, overlays, and toolbars are shown when _nothing_ is selected
//  - Show the D&D "grid" (gray lines) when something is selected
//  - Show the module overlays and toolbars when something is selected
//  - Do _not_ show container overlays and toolbars when something is selected
const getShouldCalculateContainerToolbars = createSelector(getIsAnythingSelected, isAnythingSelected => !isAnythingSelected);

// Get the deepest row/column handle _excluding_ the top-most section row
export const getCurrentDeepestRowOrColumnIdWithDragHandle = createSelector(getCurrentDragHandles, currentDragHandles => {
  if (currentDragHandles) {
    for (const handle of currentDragHandles) {
      if (handle.type === ROW_DRAG_HANDLE || handle.type === COLUMN_DRAG_HANDLE || handle.type === HORIZONTAL_STACK_DRAG_HANDLE || handle.type === VERTICAL_STACK_DRAG_HANDLE || handle.type === TABLE_DRAG_HANDLE) {
        return handle.id;
      }
    }
  }
  return null;
});
export const getCurrentTopmostRowIdWithDragHandle = createSelector(getCurrentDragHandles, currentDragHandles => {
  const hasTopmostRowDragHandle = currentDragHandles && currentDragHandles.length > 0 && currentDragHandles.at(-1).type === SECTION_DRAG_HANDLE;
  if (hasTopmostRowDragHandle) {
    return currentDragHandles.at(-1).id;
  }
  return null;
});
const getMeasuredToolbarDimensions = createSelector(getLayoutSectionDndState, state => state.measuredToolbarDimensions);
const getNumberOfToolbarMeasurements = createSelector(getMeasuredToolbarDimensions, measuredToolbarDimensions => Object.values(measuredToolbarDimensions).map(measurementsForType => Object.keys(measurementsForType).length).reduce((t, size) => t + size, 0));
const getNumberOfResponsiveToolbarTypes = createSelector(getHasAnyFlexColumns, getHasAnyLayoutSections, (hasAnyFlexColumns, hasAnyLayoutSections) => {
  let numToolbarTypes = 1;
  if (hasAnyFlexColumns) {
    numToolbarTypes += 1;
  }
  if (hasAnyLayoutSections) {
    numToolbarTypes += NUMBER_DND_AREA_TOOLBAR_TYPES;
  }
  return numToolbarTypes;
});
export const getHasAllResponsiveToolbarMeasurements = createSelector(getNumberOfToolbarMeasurements, getNumberOfResponsiveToolbarTypes, (numberOfToolbarMeasurements, numberOfResponsiveToolbarTypes) => numberOfToolbarMeasurements >= RESPONSIVE_SIZES.length * numberOfResponsiveToolbarTypes);

// Returns an object like { default, medium, small }
const collectDimensionForAllSizes = (name, dimension, measuredToolbarDimensions) => RESPONSIVE_SIZES.reduce((result, size) => {
  let measuredSize = 0;
  measuredSize = get(measuredToolbarDimensions, [name, size, dimension]);
  result[size] = measuredSize;
  return result;
}, {});
export const getMeasuredWidthsOfModuleOutsideContainerToolbarSizes = createSelector(getMeasuredToolbarDimensions, getIsInNonDefaultBreakpointMode, (measuredToolbarDimensions, isInNonDefaultBreakpointMode) => collectDimensionForAllSizes(isInNonDefaultBreakpointMode ? TOOLBAR_TYPES.MOBILE.MODULE_OUTSIDE_CONTAINER_TOOLBAR_TYPE : TOOLBAR_TYPES.DESKTOP.MODULE_OUTSIDE_CONTAINER_TOOLBAR_TYPE, 'width', measuredToolbarDimensions));
export const getMeasuredWidthsOfModuleInRichTextToolBarSizes = createSelector(getMeasuredToolbarDimensions, getIsInNonDefaultBreakpointMode, (measuredToolbarDimensions, isInNonDefaultBreakpointMode) => collectDimensionForAllSizes(isInNonDefaultBreakpointMode ? TOOLBAR_TYPES.MOBILE.MODULE_IN_RICH_TEXT : TOOLBAR_TYPES.DESKTOP.MODULE_IN_RICH_TEXT, 'width', measuredToolbarDimensions));
export const getMeasuredWidthsOfModuleInFlexColumnToolbarSizes = createSelector(getMeasuredToolbarDimensions, getIsInNonDefaultBreakpointMode, (measuredToolbarDimensions, isInNonDefaultBreakpointMode) => collectDimensionForAllSizes(isInNonDefaultBreakpointMode ? TOOLBAR_TYPES.MOBILE.MODULE_IN_FLEX_COLUMN_TOOLBAR_TYPE : TOOLBAR_TYPES.DESKTOP.MODULE_IN_FLEX_COLUMN_TOOLBAR_TYPE, 'width', measuredToolbarDimensions));
const getMeasuredWidthsOfSectionToolbarSizes = createSelector(getMeasuredToolbarDimensions, getIsInNonDefaultBreakpointMode, (measuredToolbarDimensions, isInNonDefaultBreakpointMode) => collectDimensionForAllSizes(isInNonDefaultBreakpointMode ? TOOLBAR_TYPES.MOBILE.SECTION_TOOLBAR_TYPE : TOOLBAR_TYPES.DESKTOP.SECTION_TOOLBAR_TYPE, 'width', measuredToolbarDimensions));
const getMeasuredWidthsOfHeaderToolbarSizes = createSelector(getMeasuredToolbarDimensions, getIsInNonDefaultBreakpointMode, (measuredToolbarDimensions, isInNonDefaultBreakpointMode) => collectDimensionForAllSizes(isInNonDefaultBreakpointMode ? TOOLBAR_TYPES.MOBILE.HEADER_TOOLBAR_TYPE : TOOLBAR_TYPES.DESKTOP.HEADER_TOOLBAR_TYPE, 'width', measuredToolbarDimensions));
const getMeasuredWidthsOfInsertNewSectionHandleSizes = createSelector(getMeasuredToolbarDimensions, getIsInNonDefaultBreakpointMode, (measuredToolbarDimensions, isInNonDefaultBreakpointMode) => collectDimensionForAllSizes(isInNonDefaultBreakpointMode ? TOOLBAR_TYPES.MOBILE.INSERT_NEW_SECTION_HANDLE_TYPE : TOOLBAR_TYPES.DESKTOP.INSERT_NEW_SECTION_HANDLE_TYPE, 'width', measuredToolbarDimensions));
const getMeasuredWidthsOfColumnToolbarSizes = createSelector(getMeasuredToolbarDimensions, getIsInNonDefaultBreakpointMode, (measuredToolbarDimensions, isInNonDefaultBreakpointMode) => collectDimensionForAllSizes(isInNonDefaultBreakpointMode ? TOOLBAR_TYPES.MOBILE.COLUMN_TOOLBAR_TYPE : TOOLBAR_TYPES.DESKTOP.COLUMN_TOOLBAR_TYPE, 'width', measuredToolbarDimensions));
const getMeasuredHeightsOfRowToolbarSizes = createSelector(getMeasuredToolbarDimensions, getIsInNonDefaultBreakpointMode, (measuredToolbarDimensions, isInNonDefaultBreakpointMode) => collectDimensionForAllSizes(isInNonDefaultBreakpointMode ? TOOLBAR_TYPES.MOBILE.ROW_TOOLBAR_TYPE : TOOLBAR_TYPES.DESKTOP.ROW_TOOLBAR_TYPE, 'height', measuredToolbarDimensions));
const getMeasuredHeightsOfRowToolbarWithHideIconSizes = createSelector(getMeasuredToolbarDimensions, measuredToolbarDimensions => collectDimensionForAllSizes(TOOLBAR_TYPES.MOBILE.ROW_TOOLBAR_WITH_HIDE_ICON_TYPE, 'height', measuredToolbarDimensions));
const getMeasuredWidthsOfDndAreaModuleToolbarSizes = createSelector(getMeasuredToolbarDimensions, getIsInNonDefaultBreakpointMode, (measuredToolbarDimensions, isInNonDefaultBreakpointMode) => collectDimensionForAllSizes(isInNonDefaultBreakpointMode ? TOOLBAR_TYPES.MOBILE.MODULE_TOOLBAR_TYPE : TOOLBAR_TYPES.DESKTOP.MODULE_TOOLBAR_TYPE, 'width', measuredToolbarDimensions));
const getMeasuredWidthsOfAdvancedModuleWithoutAccessToolbarSizes = createSelector([getMeasuredToolbarDimensions, getIsInNonDefaultBreakpointMode], (measuredToolbarDimensions, isInNonDefaultBreakpointMode) => collectDimensionForAllSizes(isInNonDefaultBreakpointMode ? TOOLBAR_TYPES.MOBILE.ADVANCED_MODULE_WITHOUT_ACCESS : TOOLBAR_TYPES.DESKTOP.ADVANCED_MODULE_WITHOUT_ACCESS, 'width', measuredToolbarDimensions));
const getMeasuredWidthsOfEditableModuleWithoutAccessToolbarSizes = createSelector([getMeasuredToolbarDimensions], measuredToolbarDimensions => {
  return collectDimensionForAllSizes(TOOLBAR_TYPES.DESKTOP.EDITABLE_MODULE_WITHOUT_ACCESS, 'width', measuredToolbarDimensions);
});
const getMeasuredWidthsOfStaticModuleToolbarSizes = createSelector(getMeasuredToolbarDimensions, getIsInNonDefaultBreakpointMode, (measuredToolbarDimensions, isInNonDefaultBreakpointMode) => collectDimensionForAllSizes(isInNonDefaultBreakpointMode ? TOOLBAR_TYPES.MOBILE.MODULE_OUTSIDE_CONTAINER_TOOLBAR_TYPE : TOOLBAR_TYPES.DESKTOP.MODULE_OUTSIDE_CONTAINER_TOOLBAR_TYPE, 'width', measuredToolbarDimensions));
const getMeasuredWidthsOfEmptyContainerToolbarSizes = createSelector(getMeasuredToolbarDimensions, getIsInNonDefaultBreakpointMode, (measuredToolbarDimensions, isInNonDefaultBreakpointMode) => collectDimensionForAllSizes(isInNonDefaultBreakpointMode ? TOOLBAR_TYPES.MOBILE.EMPTY_CONTAINER_TOOLBAR_TYPE : TOOLBAR_TYPES.DESKTOP.EMPTY_CONTAINER_TOOLBAR_TYPE, 'width', measuredToolbarDimensions));
const getMeasuredWidthsOfGridTableToolbarSizes = createSelector(getMeasuredToolbarDimensions, getIsInNonDefaultBreakpointMode, (measuredToolbarDimensions, isInNonDefaultBreakpointMode) => {
  const dimensions = collectDimensionForAllSizes(isInNonDefaultBreakpointMode ? TOOLBAR_TYPES.MOBILE.GRID_TABLE_TOOLBAR : TOOLBAR_TYPES.DESKTOP.GRID_TABLE_TOOLBAR, 'width', measuredToolbarDimensions);
  return dimensions;
});
const getMeasuredWidthsOfVerticalStackToolbarSizes = createSelector(getMeasuredToolbarDimensions, getIsInNonDefaultBreakpointMode, (measuredToolbarDimensions, isInNonDefaultBreakpointMode) => collectDimensionForAllSizes(isInNonDefaultBreakpointMode ? TOOLBAR_TYPES.MOBILE.VERTICAL_STACK_TOOLBAR : TOOLBAR_TYPES.DESKTOP.VERTICAL_STACK_TOOLBAR, 'width', measuredToolbarDimensions));
const getMeasuredHeightsOfHorizontalStackToolbarSizes = createSelector(getMeasuredToolbarDimensions, getIsInNonDefaultBreakpointMode, (measuredToolbarDimensions, isInNonDefaultBreakpointMode) => collectDimensionForAllSizes(isInNonDefaultBreakpointMode ? TOOLBAR_TYPES.MOBILE.HORIZONTAL_STACK_TOOLBAR : TOOLBAR_TYPES.DESKTOP.HORIZONTAL_STACK_TOOLBAR, 'height', measuredToolbarDimensions));

// TODO: CR - See if we can isolate this to a MODULE drag handle to make these keys required

const getMeasuredWidthHelperFor = ({
  dragHandle,
  measuredWidthsOfDndAreaModuleToolbarSizes,
  measuredWidthsOfStaticModuleToolbarSizes,
  measuredWidthsOfModuleInFlexColumnToolbarSizes,
  measuredWidthsOfModuleInRichTextToolBarSizes,
  measuredWidthsOfHeaderToolbarSizes,
  isDataAuthoringModeActive
}) => {
  if (dragHandle.isHeader || dragHandle.isFooter) {
    return measuredWidthsOfHeaderToolbarSizes;
  }
  if (dragHandle.isStaticModule || dragHandle.isGlobalGroup || dragHandle.isGlobalPartial) {
    return measuredWidthsOfStaticModuleToolbarSizes;
  } else if (dragHandle.isPostBodyModule || dragHandle.isModuleInRichText) {
    return measuredWidthsOfModuleInRichTextToolBarSizes;
  } else if (dragHandle.isFlexColumnModule) {
    return measuredWidthsOfModuleInFlexColumnToolbarSizes;
  } else if (isDataAuthoringModeActive) {
    // @TODO: This needs rethinking because not all SCP modules use static toolbar sizes by default
    return measuredWidthsOfStaticModuleToolbarSizes;
  } else {
    return measuredWidthsOfDndAreaModuleToolbarSizes;
  }
};
export const getSelectedItemPositionInfo = createSelector(getSelectedItemId, getSelectedContainerId, getNodePositionsByConfigAndId, (selectedItemId, selectedContainerId, nodePositionsByConfigAndId) => {
  if (selectedItemId) {
    const selectedInfo = findNodePositionForLookupId(nodePositionsByConfigAndId, selectedItemId, selectedContainerId);
    // if we can't find the position, it's still helpful to have the selectedItemId
    // particularly when a module is newly added to the page
    return selectedInfo || {
      id: selectedItemId,
      __isFakeNodePosition: true
    };
  }
  return undefined;
});
export const getHighlightedNodePositionInfo = createSelector(getHighlightedWidgetId, getHighlightedWidgetContainerId, getNodePositionsByConfigAndId, (highlightedWidgetId, highlightedWidgetContainerId, nodePositionsByConfigAndId) => {
  if (highlightedWidgetId) {
    const highlightedWidgetInfo = findNodePositionForLookupId(nodePositionsByConfigAndId, highlightedWidgetId, highlightedWidgetContainerId);
    return highlightedWidgetInfo;
  }
  return undefined;
});
export const getHasTopmostRowToolbarHovered = createSelector(getHoveredDragHandleType, getDeepestHoveredNodePositionInfo, getIsAnythingDragging, (hoveredDragHandleType, deepestNodeInfo, isAnythingDragging) => Boolean(hoveredDragHandleType === TOPMOST_SECTION_ROW_DRAG_HANDLE || hoveredDragHandleType === SECTION_DRAG_HANDLE || !isAnythingDragging && deepestNodeInfo && deepestNodeInfo.isRow && deepestNodeInfo.depth === 1));
export const getHasTopmostRowToolbarHoveredOrSelected = createSelector(getHasTopmostRowToolbarHovered, getSelectedItemPositionInfo, (hasTopmostRowToolbarHovered, selectedItemPositionInfo) => {
  if (selectedItemPositionInfo) {
    return Boolean(selectedItemPositionInfo.isRow && selectedItemPositionInfo.depth === 1);
  }
  return hasTopmostRowToolbarHovered;
});
export const getHasModuleToolbarHovered = createSelector(getHoveredDragHandleType, hoveredDragHandleType => hoveredDragHandleType === MODULE_DRAG_HANDLE);
export const getHasColumnToolbarHoveredOrSelected = createSelector(getHoveredDragHandleType, getDeepestHoveredNodePositionInfo, getIsAnythingDragging, getSelectedItemPositionInfo, (hoveredDragHandleType, deepestNodeInfo, isAnythingDragging, selectedItemPositionInfo) => {
  if (selectedItemPositionInfo) {
    return Boolean(selectedItemPositionInfo.isColumn && !selectedItemPositionInfo.isModule && !selectedItemPositionInfo.isRow && !selectedItemPositionInfo.isTopMostRow);
  }
  return Boolean(hoveredDragHandleType === COLUMN_DRAG_HANDLE || !isAnythingDragging && deepestNodeInfo && deepestNodeInfo.isColumn && !deepestNodeInfo.isModule && !deepestNodeInfo.isRow && !deepestNodeInfo.isTopMostRow);
});
export const getHasRowToolbarHoveredOrSelected = createSelector(getHoveredDragHandleType, getDeepestHoveredNodePositionInfo, getIsAnythingDragging, getSelectedItemPositionInfo, (hoveredDragHandleType, deepestNodeInfo, isAnythingDragging, selectedItemPositionInfo) => {
  const isHoveredDragHandleOrDeepestNodeIsRow = Boolean(hoveredDragHandleType === ROW_DRAG_HANDLE || !isAnythingDragging && deepestNodeInfo && deepestNodeInfo.isRow && !(deepestNodeInfo.depth === 1));
  if (selectedItemPositionInfo) {
    return Boolean(selectedItemPositionInfo.isRow && !(selectedItemPositionInfo.depth === 1));
  }
  return isHoveredDragHandleOrDeepestNodeIsRow;
});
export const getHasHorizontalStackToolbarHoveredOrSelected = createSelector(getHoveredDragHandleType, getDeepestHoveredNodePositionInfo, getIsAnythingDragging, getSelectedItemPositionInfo, (hoveredDragHandleType, deepestNodeInfo, isAnythingDragging, selectedItemPositionInfo) => {
  const isHoveredDragHandleOrDeepestNodeIsHorizontalStack = Boolean(hoveredDragHandleType === HORIZONTAL_STACK_DRAG_HANDLE || !isAnythingDragging && deepestNodeInfo && deepestNodeInfo.type === layoutNodeTypes.GRID_LAYOUT_HORIZONTAL_STACK && !(deepestNodeInfo.depth === 1));
  if (selectedItemPositionInfo) {
    return Boolean(selectedItemPositionInfo.type === layoutNodeTypes.GRID_LAYOUT_HORIZONTAL_STACK && !(selectedItemPositionInfo.depth === 1));
  }
  return isHoveredDragHandleOrDeepestNodeIsHorizontalStack;
});
export const getHasGridTableToolbarHoveredOrSelected = createSelector(getHoveredDragHandleType, getDeepestHoveredNodePositionInfo, getIsAnythingDragging, getSelectedItemPositionInfo, (hoveredDragHandleType, deepestNodeInfo, isAnythingDragging, selectedItemPositionInfo) => {
  const isHoveredDragHandleOrDeepestNodeIsGridTable = Boolean(hoveredDragHandleType === TABLE_DRAG_HANDLE || !isAnythingDragging && deepestNodeInfo && deepestNodeInfo.type === layoutNodeTypes.GRID_LAYOUT_GRID && !(deepestNodeInfo.depth === 1));
  if (selectedItemPositionInfo) {
    return Boolean(selectedItemPositionInfo.type === layoutNodeTypes.GRID_LAYOUT_GRID && !(selectedItemPositionInfo.depth === 1));
  }
  return isHoveredDragHandleOrDeepestNodeIsGridTable;
});
export const getHasVerticalStackToolbarHoveredOrSelected = createSelector(getHoveredDragHandleType, getDeepestHoveredNodePositionInfo, getIsAnythingDragging, getSelectedItemPositionInfo, (hoveredDragHandleType, deepestNodeInfo, isAnythingDragging, selectedItemPositionInfo) => {
  const isHoveredDragHandleOrDeepestNodeIsVerticalStack = Boolean(hoveredDragHandleType === VERTICAL_STACK_DRAG_HANDLE || !isAnythingDragging && deepestNodeInfo && deepestNodeInfo.type === layoutNodeTypes.GRID_LAYOUT_VERTICAL_STACK && !(deepestNodeInfo.depth === 1));
  if (selectedItemPositionInfo) {
    return Boolean(selectedItemPositionInfo.type === layoutNodeTypes.GRID_LAYOUT_VERTICAL_STACK && !(selectedItemPositionInfo.depth === 1));
  }
  return isHoveredDragHandleOrDeepestNodeIsVerticalStack;
});
export const getHoveredToolbarInfo = createSelector(getHasRowToolbarHoveredOrSelected, getHasColumnToolbarHoveredOrSelected, getHasModuleToolbarHovered, getHasTopmostRowToolbarHoveredOrSelected, getDeepestHoveredNodePositionInfo, (hasRowToolbarHoveredOrSelected, hasColumnToolbarHoveredOrSelected, hasModuleToolbarHovered, hasTopmostRowToolbarHoveredOrSelected, deepestHoveredNodePositionInfo) => {
  const hasToolbarHovered = hasRowToolbarHoveredOrSelected || hasColumnToolbarHoveredOrSelected || hasModuleToolbarHovered || hasTopmostRowToolbarHoveredOrSelected;
  if (hasToolbarHovered) {
    return deepestHoveredNodePositionInfo;
  }
  return null;
});
export const getHoveredModuleRowOrColumnInfo = createSelector(getHoveredPositionsDeepestFirst, getDeepestHoveredNodePositionInfo, getCurrentHoveredDragHandle, getIsAnythingDragging, getShouldCalculateContainerToolbars, getNodePositionsByConfigAndId, getIsAnyResizeHandleHovered, getHasTopmostRowToolbarHoveredOrSelected, (hoveredPositionsDeepestFirst, deepestNodeInfo, currentHoveredDragHandle, isAnythingDragging, shouldCalculateContainerToolbars, nodePositionsByConfigAndId, isResizeHandleHovered, hasTopmostRowToolbarHoveredOrSelected) => {
  const canShowHoverUI = !isAnythingDragging && !isResizeHandleHovered;
  if (canShowHoverUI) {
    //used for checking if user is dragging a section
    const isTopMostRow = hasTopmostRowToolbarHoveredOrSelected;
    if (currentHoveredDragHandle) {
      const hoverItem = hoveredPositionsDeepestFirst.find(pos => pos.id === currentHoveredDragHandle.id);

      // Get the position of the node referenced by the currently hovered toolbar
      const nodePosition = hoverItem && findNodePositionFor(nodePositionsByConfigAndId, hoverItem);
      if (nodePosition) {
        return nodePosition;
      }
    } else if (deepestNodeInfo) {
      const {
        isColumn,
        numChildRows,
        isRow,
        numChildColumns,
        isStaticModule,
        isFlexColumnModule,
        isGlobalGroup,
        isGlobalPartial,
        isFixedPosition,
        isAbsolutePosition,
        isPostBodyModule,
        isModuleInRichText,
        isHeader,
        isFooter,
        depth,
        type
      } = deepestNodeInfo;
      const hasNonStaticPosition = isFixedPosition || isAbsolutePosition;
      const isAnyThingOutsideDndArea = isStaticModule || isFlexColumnModule || isGlobalGroup || isGlobalPartial || isHeader || isFooter || hasNonStaticPosition || isPostBodyModule || isModuleInRichText;
      if (depth && depth > 0) {
        if (
        // Show a "module" overlay for an empty column or row
        isColumn && numChildRows === 0 || isRow && numChildColumns === 0 || type === layoutNodeTypes.GRID_LAYOUT_MODULE || !isResizeHandleHovered && shouldCalculateContainerToolbars || isTopMostRow) {
          return deepestNodeInfo;
        }
      } else if (isAnyThingOutsideDndArea) {
        // If the deepest node info is outside a layout section, just return that as the hovered module info
        return deepestNodeInfo;
      }
    }
  }
  return null;
});
export const getIsInlineEditableFieldFocused = createSelector([getLayoutSectionDndState], layoutSectionDndState => layoutSectionDndState.isInlineEditableFieldFocused);
const getCurrentModuleToolbarInfoAuthDeps = createSelector([getIsMissingAccessToSomeAdvancedModule, getHasPaymentsReadAccess, getHasPersonalizationAccess], (isMissingAccessToSomeAdvancedModule, hasPaymentsAccess, hasPersonalizationAccess) => ({
  isMissingAccessToSomeAdvancedModule,
  hasPaymentsAccess,
  hasPersonalizationAccess
}));
const getCurrentModuleToolbarSizes = createSelector([getMeasuredWidthsOfDndAreaModuleToolbarSizes, getMeasuredWidthsOfStaticModuleToolbarSizes, getMeasuredWidthsOfModuleInFlexColumnToolbarSizes, getMeasuredWidthsOfModuleInRichTextToolBarSizes, getMeasuredWidthsOfAdvancedModuleWithoutAccessToolbarSizes, getMeasuredWidthsOfEditableModuleWithoutAccessToolbarSizes, getMeasuredWidthsOfHeaderToolbarSizes], (measuredWidthsOfDndAreaModuleToolbarSizes, measuredWidthsOfStaticModuleToolbarSizes, measuredWidthsOfModuleInFlexColumnToolbarSizes, measuredWidthsOfModuleInRichTextToolBarSizes, measuredWidthsOfAdvancedModuleWithoutAccessToolbarSizes, measuredWidthsOfEditableModuleWithoutAccessToolbarSizes, measuredWidthsOfHeaderToolbarSizes) => ({
  measuredWidthsOfDndAreaModuleToolbarSizes,
  measuredWidthsOfStaticModuleToolbarSizes,
  measuredWidthsOfModuleInFlexColumnToolbarSizes,
  measuredWidthsOfModuleInRichTextToolBarSizes,
  measuredWidthsOfAdvancedModuleWithoutAccessToolbarSizes,
  measuredWidthsOfEditableModuleWithoutAccessToolbarSizes,
  measuredWidthsOfHeaderToolbarSizes
}));
const getCurrentModuleToolbarHandleInfo = createSelector([getIsDraggingResizeHandle, getIsAnyResizeHandleHovered, getHasInsertNewSectionHandleHovered], (isDraggingResizeHandle, isResizeHandleHovered, isInsertNewSectionHandleHovered) => ({
  isDraggingResizeHandle,
  isResizeHandleHovered,
  isInsertNewSectionHandleHovered
}));
const getSelectedItemInfo = createSelector([getSelectedItemId, getSelectedItemPositionInfo], (selectedItemId, selectedItemPositionInfo) => ({
  selectedItemId,
  selectedItemPositionInfo
}));
export const getCurrentModuleToolbarInfo = createSelector([getCurrentDragHandles, getNodePositionsByConfigAndId, getPreviewViewportWidth, getScrollLeftPosition, getIsPatagoniaSidebarCollapsed, getIsDataAuthoringModeActive, getIsInlineEditableFieldFocused, getCurrentModuleToolbarInfoAuthDeps, getCurrentModuleToolbarSizes, getCurrentModuleToolbarHandleInfo, getSelectedItemInfo, getPreviewIframeLeftOffset], (currentDragHandles, nodePositionsByConfigAndId, previewViewportWidth, scrollLeftPosition, isPatagoniaSidebarCollapsed, isDataAuthoringModeActive, isInlineEditableFieldFocused, authDeps, currentModuleToolbarSizes, currentModuleToolbarHandleInfo, selectedItemInfo, iframeLeftOffset) => {
  const {
    isDraggingResizeHandle,
    isResizeHandleHovered,
    isInsertNewSectionHandleHovered
  } = currentModuleToolbarHandleInfo;
  const {
    selectedItemId,
    selectedItemPositionInfo
  } = selectedItemInfo;
  const {
    isMissingAccessToSomeAdvancedModule,
    hasPaymentsAccess,
    hasPersonalizationAccess
  } = authDeps;
  const {
    measuredWidthsOfDndAreaModuleToolbarSizes,
    measuredWidthsOfStaticModuleToolbarSizes,
    measuredWidthsOfModuleInFlexColumnToolbarSizes,
    measuredWidthsOfModuleInRichTextToolBarSizes,
    measuredWidthsOfAdvancedModuleWithoutAccessToolbarSizes,
    measuredWidthsOfEditableModuleWithoutAccessToolbarSizes,
    measuredWidthsOfHeaderToolbarSizes
  } = currentModuleToolbarSizes;
  const canShowModuleToolbar = !isDraggingResizeHandle && !isResizeHandleHovered && !isInsertNewSectionHandleHovered;
  if (!canShowModuleToolbar || selectedItemPositionInfo && !selectedItemPositionInfo.isModule) {
    return null;
  }
  const useItemPosition = selectedItemPositionInfo && !(selectedItemPositionInfo.id === 'post_body' || selectedItemPositionInfo.isPostBodyModule);
  const dragHandleOrHoverItem = useItemPosition ? selectedItemPositionInfo : getDragHandleByType(currentDragHandles, MODULE_DRAG_HANDLE);
  if (dragHandleOrHoverItem) {
    const id = dragHandleOrHoverItem.id;
    const type = dragHandleOrHoverItem.type;
    const isStaticModule = dragHandleOrHoverItem.isStaticModule;
    const isStaticSectionModule = dragHandleOrHoverItem.isStaticSectionModule;
    const isFlexColumnModule = dragHandleOrHoverItem.isFlexColumnModule;
    const isPostBodyModule = dragHandleOrHoverItem.isPostBodyModule;
    const isModuleInRichText = dragHandleOrHoverItem.isModuleInRichText;
    const isGlobalGroup = dragHandleOrHoverItem.isGlobalGroup;
    const isGlobalPartial = dragHandleOrHoverItem.isGlobalPartial;
    const isHeader = dragHandleOrHoverItem.isHeader;
    const isFooter = dragHandleOrHoverItem.isFooter;
    const isHeaderOrFooter = isHeader || isFooter;
    const isSelected = Boolean(selectedItemId) && id === selectedItemId;
    const showEditModuleOnSelected = shouldShowEditModuleOnSelected({
      isPatagoniaSidebarCollapsed,
      // TODO: CR - This was originally an incorrect parameter
      moduleType: type
    });
    const isStaticOrNestedModule = isStaticModule || isModuleInRichText;
    const shouldShowToolbar = Boolean(!isSelected || isSelected && !(isGlobalGroup || isGlobalPartial));
    const modulePosition = findNodePositionFor(nodePositionsByConfigAndId, dragHandleOrHoverItem);
    if (modulePosition && shouldShowToolbar) {
      const measuredWidths = getMeasuredWidthHelperFor({
        // in common with this param, but you can still reference all of those values on dragHandleOrHoverItem directly
        // @ts-ignore CR - TS says that one of the types in dragHandleOrHoverItem has nothing
        dragHandle: dragHandleOrHoverItem,
        measuredWidthsOfDndAreaModuleToolbarSizes,
        measuredWidthsOfStaticModuleToolbarSizes,
        measuredWidthsOfModuleInFlexColumnToolbarSizes,
        measuredWidthsOfModuleInRichTextToolBarSizes,
        measuredWidthsOfHeaderToolbarSizes,
        isDataAuthoringModeActive
      });
      let measuredWidthsToUse = measuredWidths;
      if (isMissingAccessToSomeAdvancedModule && getIsModuleIdInAdvancedModuleIdsWithoutAccessMap(id)) {
        const advancedModuleWithoutAccessInfo = getAdvancedModuleWithoutAccessInfo(id);
        const isEditableModuleWithoutAccess = advancedModuleWithoutAccessInfo.isRichTextModule || advancedModuleWithoutAccessInfo.isHsVideoModule;
        measuredWidthsToUse = isEditableModuleWithoutAccess && id !== 'post_body' ? measuredWidthsOfEditableModuleWithoutAccessToolbarSizes : measuredWidthsOfAdvancedModuleWithoutAccessToolbarSizes;
      } else if (!hasPaymentsAccess && getIsModuleIdInPaymentsModulesWithoutAccessSet(id)) {
        measuredWidthsToUse = measuredWidthsOfAdvancedModuleWithoutAccessToolbarSizes;
      } else if (!hasPersonalizationAccess && getIsModuleInPersonalizationTokensWithoutAccessMap(id)) {
        measuredWidthsToUse = measuredWidthsOfEditableModuleWithoutAccessToolbarSizes;
      }
      const shouldModifyPlacement = isSelected && isInlineEditableFieldFocused && !isStaticOrNestedModule;
      const topModifier = isHeaderOrFooter ? 10 : shouldModifyPlacement ? -2 : 1;
      const leftModifer = isHeaderOrFooter ? -10 : shouldModifyPlacement ? 2 : -1;
      const toolbarHeight = PINNED_TOOLBAR_HEIGHT;
      const {
        responsiveSize,
        top: adjustedTop,
        left: adjustedLeft,
        width
      } = adjustResponsiveToolbarToStayInViewPort({
        measuredWidths: measuredWidthsToUse,
        left: modulePosition.left + leftModifer,
        top: modulePosition.top + topModifier,
        width: modulePosition.width,
        previewViewportWidth,
        scrollLeftPosition,
        toolbarHeight,
        iframeLeftOffset,
        isSelected,
        showEditModuleOnSelected
      });
      const result = {
        type,
        id,
        layoutSectionId: dragHandleOrHoverItem.layoutSectionId,
        gridLayoutId: dragHandleOrHoverItem.gridLayoutId,
        layoutNodeType: dragHandleOrHoverItem.layoutNodeType,
        isGridCell: dragHandleOrHoverItem.isGridCell,
        depth: dragHandleOrHoverItem.depth,
        top: adjustedTop,
        width,
        left: adjustedLeft,
        height: toolbarHeight,
        isFixedPosition: modulePosition.isFixedPosition,
        isStaticModule,
        isStaticSectionModule,
        isPostBodyModule,
        isModuleInRichText,
        isFlexColumnModule,
        isGlobalGroup,
        isGlobalPartial,
        isHeader,
        isFooter,
        responsiveSize
      };
      return result;
    }
  }
  return null;
});
const getIsSectionsEnabled = () => getFeatureFlag(FEATURE_FLAGS.sections);
export const getCurrentInsertNewSectionToolbarInfo = createSelector(getCurrentDragHandles, getTargetedLayoutSectionId, getTargetedDndAreaNodePositionsById, getShouldCalculateContainerToolbars, getMeasuredWidthsOfInsertNewSectionHandleSizes, getIsDraggingResizeHandle, getNodePositionsByConfigAndId, getSecondToLastHoveredItem, getIsSectionsEnabled, getHasSectionsLibraryAccess, (currentDragHandles, targetedLayoutSectionId, targetedNodePositionsById, shouldCalculateContainerToolbars, measuredWidthsOfInsertNewSectionHandleSizes, isDraggingResizeHandle, nodePositionsByConfigAndId, sectionHoverPosition, isSectionsEnabled, hasSectionsLibraryAccess) => {
  const canShowInsertNewSectionToolbar = shouldCalculateContainerToolbars && !isDraggingResizeHandle && targetedNodePositionsById && isSectionsEnabled;
  if (!canShowInsertNewSectionToolbar) {
    return null;
  }
  const handle = getDragHandleByType(currentDragHandles, INSERT_NEW_SECTION_HANDLE);
  const nodePosition = findNodePositionFor(nodePositionsByConfigAndId, handle);
  if (handle && nodePosition && sectionHoverPosition) {
    const type = handle.type;
    const responsiveSize = findAppropriateToolbarSize(measuredWidthsOfInsertNewSectionHandleSizes, nodePosition.width);
    const handleWidth = measuredWidthsOfInsertNewSectionHandleSizes[responsiveSize];
    let targetBeforeOrAfter;
    let top;
    let highlightTop;
    if (sectionHoverPosition.topOrBottomHovered === TOP) {
      targetBeforeOrAfter = BEFORE;
      top = nodePosition.top - ROUNDED_BUTTON_HEIGHT / 2;
      highlightTop = nodePosition.top;
    } else {
      targetBeforeOrAfter = AFTER;
      top = nodePosition.bottom - ROUNDED_BUTTON_HEIGHT / 2;
      highlightTop = nodePosition.top + nodePosition.height;
    }
    const left = nodePosition.left + nodePosition.width / 2 - handleWidth / 2;

    // Somewhat hacky fix to prevent top-most-row action toolbars from bleeding off the top-most
    // IPEUI iframe edge.
    if (top < 0) {
      top = 0;
    }
    return {
      type,
      id: handle.id,
      layoutSectionId: targetedLayoutSectionId,
      targetBeforeOrAfter,
      isEmptyLayoutSection: handle.isEmptyLayoutSection,
      parentId: handle.parentId,
      depth: handle.depth,
      top,
      left,
      height: ROUNDED_BUTTON_HEIGHT,
      width: handleWidth,
      highlightTop,
      highlightLeft: nodePosition.left,
      highlightWidth: nodePosition.width,
      responsiveSize
    };
  } else if (handle && nodePosition && handle.isEmptyLayoutSection && !hasSectionsLibraryAccess) {
    // Case of an empty layout section
    const type = handle.type;
    const responsiveSize = findAppropriateToolbarSize(measuredWidthsOfInsertNewSectionHandleSizes, nodePosition.width);
    const handleWidth = measuredWidthsOfInsertNewSectionHandleSizes[responsiveSize];
    let top = nodePosition.bottom - ROUNDED_BUTTON_HEIGHT / 2;
    // Somewhat hacky fix to prevent top-most-row action toolbars from bleeding off the top-most
    // IPEUI iframe edge.
    if (top < 0) {
      top = 0;
    }
    return {
      type,
      id: handle.id,
      layoutSectionId: targetedLayoutSectionId,
      targetBeforeOrAfter: AFTER,
      isEmptyLayoutSection: handle.isEmptyLayoutSection,
      parentId: handle.parentId,
      depth: handle.depth,
      top,
      left: nodePosition.left + nodePosition.width / 2 - handleWidth / 2,
      height: ROUNDED_BUTTON_HEIGHT,
      width: handleWidth,
      highlightTop: nodePosition.top + nodePosition.height,
      highlightLeft: nodePosition.left,
      highlightWidth: nodePosition.width,
      responsiveSize
    };
  }
  return null;
});
export const getCurrentVerticalStackToolbarInfo = createSelector(getCurrentDragHandles, getTargetedGridLayoutIdIfNothingIsSelected, getShouldCalculateContainerToolbars, getMeasuredWidthsOfVerticalStackToolbarSizes, getIsDraggingResizeHandle, getIsAnyResizeHandleHovered, getHasInsertNewSectionHandleHovered, getNodePositionsByConfigAndId, getHasVerticalStackToolbarHoveredOrSelected, getSelectedItemPositionInfo, (currentDragHandles, targetedGridLayoutIdIfNothingIsSelected, shouldCalculateContainerToolbars, measuredWidthsOfVerticalStackToolbarSizes, isDraggingResizeHandle, isResizeHandleHovered, isInsertNewSectionHandleHovered, nodePositionsByConfigAndId, hasVerticalStackToolbarHoveredOrSelected, selectedItemPositionInfo) => {
  const canShowToolbar = (shouldCalculateContainerToolbars || hasVerticalStackToolbarHoveredOrSelected) && !isDraggingResizeHandle && !isResizeHandleHovered && !isInsertNewSectionHandleHovered;
  if (!canShowToolbar) {
    return null;
  }
  const dragHandleOrHoverItem = selectedItemPositionInfo !== null && selectedItemPositionInfo !== void 0 ? selectedItemPositionInfo : getDragHandleByType(currentDragHandles, VERTICAL_STACK_DRAG_HANDLE);
  const verticalStackPosition = findNodePositionFor(nodePositionsByConfigAndId, dragHandleOrHoverItem);
  if (dragHandleOrHoverItem && verticalStackPosition) {
    const type = dragHandleOrHoverItem.type;
    const id = dragHandleOrHoverItem.id;
    const responsiveSize = findAppropriateToolbarSize(measuredWidthsOfVerticalStackToolbarSizes, verticalStackPosition.width);
    const isSelected = selectedItemPositionInfo && selectedItemPositionInfo.id === id;
    const offset = isSelected && responsiveSize === 'default' ? SELECTED_TOOLBAR_OFFSET : 0;
    const actionToolbarWidth = measuredWidthsOfVerticalStackToolbarSizes[responsiveSize] - offset;
    let top = verticalStackPosition.top - EDGE_TOOLBAR_HEIGHT;

    // Somewhat hacky fix to prevent top-most-row column action toolbars from bleeding off the top-most
    // IPEUI iframe edge.
    if (top < 0) {
      top = 0;
    }
    const gridLayoutId = targetedGridLayoutIdIfNothingIsSelected || dragHandleOrHoverItem.gridLayoutId;
    const result = {
      type,
      id: dragHandleOrHoverItem.id,
      gridLayoutId,
      layoutNodeType: dragHandleOrHoverItem.layoutNodeType,
      isGridCell: dragHandleOrHoverItem.isGridCell,
      parentId: dragHandleOrHoverItem.parentId,
      depth: dragHandleOrHoverItem.depth,
      left: verticalStackPosition.left + (verticalStackPosition.width - actionToolbarWidth) / 2,
      top,
      height: EDGE_TOOLBAR_HEIGHT,
      width: actionToolbarWidth,
      responsiveSize
    };
    return result;
  }
  return null;
});
export const getCurrentHorizontalStackToolbarInfo = createSelector(getCurrentDragHandles, getTargetedGridLayoutIdIfNothingIsSelected, getShouldCalculateContainerToolbars, getMeasuredHeightsOfHorizontalStackToolbarSizes, getIsDraggingResizeHandle, getHasInsertNewSectionHandleHovered, getNodePositionsByConfigAndId, getHasHorizontalStackToolbarHoveredOrSelected, getSelectedItemPositionInfo, (currentDragHandles, targetedGridLayoutIdIfNothingIsSelected, shouldCalculateContainerToolbars, measuredHeightsOfHorizontalStackToolbarSizes, isDraggingResizeHandle, isInsertNewSectionHandleHovered, nodePositionsByConfigAndId, hasHorizontalStackToolbarHoveredOrSelected, selectedItemPositionInfo) => {
  const canShowToolbar = (shouldCalculateContainerToolbars || hasHorizontalStackToolbarHoveredOrSelected) && !isDraggingResizeHandle && !isInsertNewSectionHandleHovered;
  if (!canShowToolbar) {
    return null;
  }
  const dragHandleOrHoverItem = selectedItemPositionInfo !== null && selectedItemPositionInfo !== void 0 ? selectedItemPositionInfo : getDragHandleByType(currentDragHandles, HORIZONTAL_STACK_DRAG_HANDLE);
  const horizontalStackPosition = findNodePositionFor(nodePositionsByConfigAndId, dragHandleOrHoverItem);
  if (dragHandleOrHoverItem && horizontalStackPosition) {
    const type = dragHandleOrHoverItem.type;
    const id = dragHandleOrHoverItem.id;
    const measuredHeights = measuredHeightsOfHorizontalStackToolbarSizes;
    const responsiveSize = findAppropriateToolbarSize(measuredHeights, horizontalStackPosition.height);
    const isSelected = selectedItemPositionInfo && selectedItemPositionInfo.id === id;
    const offset = isSelected && responsiveSize === 'default' ? SELECTED_TOOLBAR_OFFSET : 0;
    const height = measuredHeights[responsiveSize] - offset;
    let left = horizontalStackPosition.left;
    const top = horizontalStackPosition.top + (horizontalStackPosition.height - height) / 2;

    // Somewhat hacky fix to prevent row action toolbars from bleeding off the left-most
    // IPEUI iframe edge.
    if (left < EDGE_TOOLBAR_HEIGHT) {
      left = EDGE_TOOLBAR_HEIGHT;
    } else if (left < 0) {
      left = 0;
    }

    // Simulate the cordinates the toolbar will seem appear after translated
    const perceivedPosition = {
      top,
      left: left - EDGE_TOOLBAR_HEIGHT
    };
    const gridLayoutId = targetedGridLayoutIdIfNothingIsSelected || dragHandleOrHoverItem.gridLayoutId;
    const result = {
      type,
      gridLayoutId,
      id: dragHandleOrHoverItem.id,
      parentId: dragHandleOrHoverItem.parentId,
      layoutNodeType: dragHandleOrHoverItem.layoutNodeType,
      isGridCell: dragHandleOrHoverItem.isGridCell,
      depth: dragHandleOrHoverItem.depth,
      top,
      height,
      left,
      width: EDGE_TOOLBAR_HEIGHT,
      perceivedPosition,
      responsiveSize
    };
    return result;
  }
  return null;
});
export const getCurrentRowToolbarInfo = createSelector(getCurrentDragHandles, getTargetedLayoutSectionIdIfNothingIsSelected, getTargetedTree, getShouldCalculateContainerToolbars, getMeasuredHeightsOfRowToolbarSizes, getMeasuredHeightsOfRowToolbarWithHideIconSizes, getIsDraggingResizeHandle, getHasInsertNewSectionHandleHovered, getNodePositionsByConfigAndId, getHasRowToolbarHoveredOrSelected, getSelectedItemPositionInfo, getIsInNonDefaultBreakpointMode, (currentDragHandles, targetedLayoutSectionIdIfNothingIsSelected, targetedTree, shouldCalculateContainerToolbars, measuredHeightsOfRowToolbarSizes, measuredHeightsOfRowToolbarWithHideIconSizes, isDraggingResizeHandle, isInsertNewSectionHandleHovered, nodePositionsByConfigAndId, hasRowToolbarHoveredOrSelected, selectedItemPositionInfo, isInNonDefaultBreakpointMode) => {
  const canShowRowToolbar = (shouldCalculateContainerToolbars || hasRowToolbarHoveredOrSelected) && !isDraggingResizeHandle && !isInsertNewSectionHandleHovered;
  if (!canShowRowToolbar) {
    return null;
  }
  const dragHandleOrHoverItem = selectedItemPositionInfo !== null && selectedItemPositionInfo !== void 0 ? selectedItemPositionInfo : getDragHandleByType(currentDragHandles, ROW_DRAG_HANDLE);
  const rowPosition = findNodePositionFor(nodePositionsByConfigAndId, dragHandleOrHoverItem);
  if (dragHandleOrHoverItem && rowPosition) {
    const type = dragHandleOrHoverItem.type;
    const id = dragHandleOrHoverItem.id;
    const children = childIdsFromNode(targetedTree, id);
    const shouldUseHideIconSizes = isInNonDefaultBreakpointMode && children.length > 1;
    const measuredHeights = shouldUseHideIconSizes ? measuredHeightsOfRowToolbarWithHideIconSizes : measuredHeightsOfRowToolbarSizes;
    const responsiveSize = findAppropriateToolbarSize(measuredHeights, rowPosition.height);
    const isSelected = selectedItemPositionInfo && selectedItemPositionInfo.id === id;
    const offset = isSelected && responsiveSize === 'default' ? SELECTED_TOOLBAR_OFFSET : 0;
    const height = measuredHeights[responsiveSize] - offset;
    let left = rowPosition.left;
    const top = rowPosition.top + (rowPosition.height - height) / 2;

    // Somewhat hacky fix to prevent row action toolbars from bleeding off the left-most
    // IPEUI iframe edge.
    if (left < EDGE_TOOLBAR_HEIGHT) {
      left = EDGE_TOOLBAR_HEIGHT;
    } else if (left < 0) {
      left = 0;
    }

    // Simulate the cordinates the toolbar will seem appear after translated
    const perceivedPosition = {
      top,
      left: left - EDGE_TOOLBAR_HEIGHT
    };
    const layoutSectionId = targetedLayoutSectionIdIfNothingIsSelected || dragHandleOrHoverItem.layoutSectionId;
    const result = {
      type,
      id: dragHandleOrHoverItem.id,
      layoutSectionId,
      parentId: dragHandleOrHoverItem.parentId,
      depth: dragHandleOrHoverItem.depth,
      top,
      height,
      left,
      width: EDGE_TOOLBAR_HEIGHT,
      perceivedPosition,
      responsiveSize
    };
    return result;
  }
  return null;
});
export const getCurrentColumnToolbarInfo = createSelector(getCurrentDragHandles, getTargetedLayoutSectionIdIfNothingIsSelected, getShouldCalculateContainerToolbars, getMeasuredWidthsOfColumnToolbarSizes, getIsDraggingResizeHandle, getIsAnyResizeHandleHovered, getHasInsertNewSectionHandleHovered, getNodePositionsByConfigAndId, getHasColumnToolbarHoveredOrSelected, getSelectedItemPositionInfo, getIsInNonDefaultBreakpointMode, getMeasuredWidthsOfInsertNewSectionHandleSizes, (currentDragHandles, targetedLayoutSectionIdIfNothingIsSelected, shouldCalculateContainerToolbars, measuredWidthsOfColumnToolbarSizes, isDraggingResizeHandle, isResizeHandleHovered, isInsertNewSectionHandleHovered, nodePositionsByConfigAndId, hasColumnToolbarHoveredOrSelected, selectedItemPositionInfo, isInNonDefaultBreakpointMode, measuredWidthsOfInsertNewSectionHandleSizes) => {
  const canShowColumnToolbar = (shouldCalculateContainerToolbars || hasColumnToolbarHoveredOrSelected) && !isDraggingResizeHandle && !isResizeHandleHovered && !isInsertNewSectionHandleHovered;
  if (!canShowColumnToolbar) {
    return null;
  }
  const dragHandleOrHoverItem = selectedItemPositionInfo !== null && selectedItemPositionInfo !== void 0 ? selectedItemPositionInfo : getDragHandleByType(currentDragHandles, COLUMN_DRAG_HANDLE);
  const columnPosition = findNodePositionFor(nodePositionsByConfigAndId, dragHandleOrHoverItem);
  if (dragHandleOrHoverItem && columnPosition) {
    var _nodePositionsByConfi, _nodePositionsByConfi2;
    const type = dragHandleOrHoverItem.type;
    const id = dragHandleOrHoverItem.id;
    const responsiveSize = findAppropriateToolbarSize(measuredWidthsOfColumnToolbarSizes, columnPosition.width);
    const isSelected = selectedItemPositionInfo && selectedItemPositionInfo.id === id;
    const offset = isSelected && responsiveSize === 'default' ? SELECTED_TOOLBAR_OFFSET : 0;
    const actionToolbarWidth = measuredWidthsOfColumnToolbarSizes[responsiveSize] - offset;
    let top = columnPosition.top - EDGE_TOOLBAR_HEIGHT;

    // Somewhat hacky fix to prevent top-most-row column action toolbars from bleeding off the top-most
    // IPEUI iframe edge.
    if (top < 0) {
      top = 0;
    }
    const layoutSectionId = targetedLayoutSectionIdIfNothingIsSelected || dragHandleOrHoverItem.layoutSectionId;
    const parentId = dragHandleOrHoverItem.parentId;
    const parentRowPos = parentId && layoutSectionId ? (_nodePositionsByConfi = nodePositionsByConfigAndId[LAYOUT_SECTIONS_CONFIG]) === null || _nodePositionsByConfi === void 0 || (_nodePositionsByConfi = _nodePositionsByConfi[layoutSectionId]) === null || _nodePositionsByConfi === void 0 ? void 0 : _nodePositionsByConfi[parentId] : undefined;
    const sectionBoundaryPos = isSelected ? undefined : findTopmostRowPosition(parentRowPos, layoutSectionId ? (_nodePositionsByConfi2 = nodePositionsByConfigAndId[LAYOUT_SECTIONS_CONFIG]) === null || _nodePositionsByConfi2 === void 0 ? void 0 : _nodePositionsByConfi2[layoutSectionId] : undefined);
    const left = adjustLeftToAvoidAddSectionButton(columnPosition, actionToolbarWidth, sectionBoundaryPos, isInNonDefaultBreakpointMode, measuredWidthsOfInsertNewSectionHandleSizes);
    const result = {
      type,
      id: dragHandleOrHoverItem.id,
      layoutSectionId,
      parentId: dragHandleOrHoverItem.parentId,
      depth: dragHandleOrHoverItem.depth,
      left,
      top,
      height: EDGE_TOOLBAR_HEIGHT,
      width: actionToolbarWidth,
      responsiveSize
    };
    return result;
  }
  return null;
});
export const getCurrentGridTableToolbarInfo = createSelector(getCurrentDragHandles, getTargetedGridLayoutIdIfNothingIsSelected, getShouldCalculateContainerToolbars, getMeasuredWidthsOfGridTableToolbarSizes, getIsDraggingResizeHandle, getIsAnyResizeHandleHovered, getHasInsertNewSectionHandleHovered, getNodePositionsByConfigAndId, getHasGridTableToolbarHoveredOrSelected, getSelectedItemPositionInfo, (currentDragHandles, targetedGridLayoutIdIfNothingIsSelected, shouldCalculateContainerToolbars, measuredWidthsOfGridTableToolbarSizes, isDraggingResizeHandle, isResizeHandleHovered, isInsertNewSectionHandleHovered, nodePositionsByConfigAndId, hasGridTableToolbarHoveredOrSelected, selectedItemPositionInfo) => {
  const canShowToolbar = (shouldCalculateContainerToolbars || hasGridTableToolbarHoveredOrSelected) && !isDraggingResizeHandle && !isResizeHandleHovered && !isInsertNewSectionHandleHovered;
  if (!canShowToolbar) {
    return null;
  }
  const dragHandleOrHoverItem = selectedItemPositionInfo !== null && selectedItemPositionInfo !== void 0 ? selectedItemPositionInfo : getDragHandleByType(currentDragHandles, TABLE_DRAG_HANDLE);
  const gridTablePosition = findNodePositionFor(nodePositionsByConfigAndId, dragHandleOrHoverItem);
  if (dragHandleOrHoverItem && gridTablePosition) {
    const type = dragHandleOrHoverItem.type;
    const id = dragHandleOrHoverItem.id;
    const responsiveSize = findAppropriateToolbarSize(measuredWidthsOfGridTableToolbarSizes, gridTablePosition.width);
    const isSelected = selectedItemPositionInfo && selectedItemPositionInfo.id === id;
    const offset = isSelected && responsiveSize === 'default' ? SELECTED_TOOLBAR_OFFSET : 0;
    const actionToolbarWidth = measuredWidthsOfGridTableToolbarSizes[responsiveSize] - offset;
    let top = gridTablePosition.top - EDGE_TOOLBAR_HEIGHT;

    // Somewhat hacky fix to prevent top-most-row column action toolbars from bleeding off the top-most
    // IPEUI iframe edge.
    if (top < 0) {
      top = 0;
    }
    const gridLayoutId = targetedGridLayoutIdIfNothingIsSelected || dragHandleOrHoverItem.gridLayoutId;
    const result = {
      type,
      id: dragHandleOrHoverItem.id,
      gridLayoutId,
      parentId: dragHandleOrHoverItem.parentId,
      layoutNodeType: dragHandleOrHoverItem.layoutNodeType,
      isGridCell: dragHandleOrHoverItem.isGridCell,
      depth: dragHandleOrHoverItem.depth,
      left: gridTablePosition.left,
      top,
      height: EDGE_TOOLBAR_HEIGHT,
      width: actionToolbarWidth,
      responsiveSize
    };
    return result;
  }
  return null;
});
export const getCurrentTopmostRowToolbarInfo = createSelector(getCurrentDragHandles, getTargetedLayoutSectionIdIfNothingIsSelected, getShouldCalculateContainerToolbars, getMeasuredWidthsOfSectionToolbarSizes, getIsDraggingResizeHandle, getHasInsertNewSectionHandleHovered, getNodePositionsByConfigAndId, getHasTopmostRowToolbarHoveredOrSelected, getTopMostRowNodeInfo, getSelectedItemPositionInfo, (currentDragHandles, targetedLayoutSectionIdIfNothingIsSelected, shouldCalculateContainerToolbars, measuredWidthsOfSectionToolbarSizes, isDraggingResizeHandle, isInsertNewSectionHandleHovered, nodePositionsByConfigAndId, hasTopmostRowToolbarHoveredOrSelected, topMostRowNodeInfo, selectedItemPositionInfo) => {
  var _ref2, _ref3, _ref4;
  const canShowTopmostRowToolbar = (shouldCalculateContainerToolbars || hasTopmostRowToolbarHoveredOrSelected) && !isDraggingResizeHandle && !isInsertNewSectionHandleHovered;
  if (!canShowTopmostRowToolbar) {
    return null;
  }
  const dragHandleOrHoverItem = (_ref2 = (_ref3 = (_ref4 = selectedItemPositionInfo) !== null && _ref4 !== void 0 ? _ref4 : getDragHandleByType(currentDragHandles, TOPMOST_SECTION_ROW_DRAG_HANDLE)) !== null && _ref3 !== void 0 ? _ref3 : getDragHandleByType(currentDragHandles, SECTION_DRAG_HANDLE)) !== null && _ref2 !== void 0 ? _ref2 : topMostRowNodeInfo;
  const rowPosition = findNodePositionFor(nodePositionsByConfigAndId, dragHandleOrHoverItem);
  if (dragHandleOrHoverItem && rowPosition) {
    const id = dragHandleOrHoverItem.id;
    const type = dragHandleOrHoverItem.type;
    const responsiveSize = findAppropriateToolbarSize(measuredWidthsOfSectionToolbarSizes, rowPosition.width);
    const isSelected = selectedItemPositionInfo && selectedItemPositionInfo.id === id;
    const offset = isSelected && responsiveSize === 'default' ? SELECTED_TOOLBAR_OFFSET : 0;
    const actionToolbarWidth = measuredWidthsOfSectionToolbarSizes[responsiveSize] - offset;
    let top = rowPosition.top - EDGE_TOOLBAR_HEIGHT;

    // Somewhat hacky fix to prevent top-most-row action toolbars from bleeding off the top-most
    // IPEUI iframe edge.
    if (top < 0) {
      top = 0;
    }
    const layoutSectionId = targetedLayoutSectionIdIfNothingIsSelected || dragHandleOrHoverItem.layoutSectionId;
    const result = {
      type,
      id: dragHandleOrHoverItem.id,
      layoutSectionId,
      parentId: dragHandleOrHoverItem.parentId,
      depth: dragHandleOrHoverItem.depth,
      gridLayoutId: dragHandleOrHoverItem.gridLayoutId,
      layoutNodeType: dragHandleOrHoverItem.layoutNodeType,
      isGridCell: dragHandleOrHoverItem.isGridCell,
      top,
      left: rowPosition.left,
      height: EDGE_TOOLBAR_HEIGHT,
      width: actionToolbarWidth,
      responsiveSize
    };
    return result;
  }
  return null;
});
export const getCurrentEmptyContainerToolbarInfo = createSelector([getCurrentDragHandles, getTargetedLayoutSectionId, getTargetedDndAreaNodePositionsById, getPreviewViewportWidth, getScrollLeftPosition, getMeasuredWidthsOfEmptyContainerToolbarSizes, getIsDraggingResizeHandle, getNodePositionsByConfigAndId, getPreviewIframeLeftOffset], (currentDragHandles, targetedLayoutSectionId, targetedDndAreaNodePositionsById, previewViewportWidth, scrollLeftPosition, measuredWidthsOfEmptyContainerToolbarSizes, isDraggingResizeHandle, nodePositionsByConfigAndId, iframeLeftOffset) => {
  const canShowToolbar = !isDraggingResizeHandle && !!targetedDndAreaNodePositionsById;
  if (!canShowToolbar) {
    return null;
  }
  const dragHandle = getDragHandleByType(currentDragHandles, EMPTY_CONTAINER_DRAG_HANDLE);
  const containerPosition = findNodePositionFor(nodePositionsByConfigAndId, dragHandle);
  if (dragHandle && containerPosition) {
    const id = dragHandle.id;
    const type = dragHandle.type;
    const {
      responsiveSize,
      top: adjustedTop,
      left: adjustedLeft,
      width
      // @ts-ignore TODO: This is missing toolbarHeight, which is required by the util
    } = adjustResponsiveToolbarToStayInViewPort({
      measuredWidths: measuredWidthsOfEmptyContainerToolbarSizes,
      left: containerPosition.left,
      top: containerPosition.top,
      width: containerPosition.width,
      previewViewportWidth,
      scrollLeftPosition,
      iframeLeftOffset
    });
    const result = {
      type,
      id,
      layoutSectionId: targetedLayoutSectionId,
      depth: dragHandle.depth,
      top: adjustedTop,
      width,
      left: adjustedLeft,
      height: PINNED_TOOLBAR_HEIGHT,
      responsiveSize
    };
    return result;
  }
  return null;
});
const EMPTY_RESIZE_HANDLE_ARRAY = [];
export const getCurrentColumnResizeHandleInfo = createSelector(getTargetedDndAreaNodePositionsById, getCurrentColumnResizeHandles, getHoveredDragHandleType, getIsAnyResizeHandleHovered, getShouldCalculateContainerToolbars, (targetedDndAreaNodePositionsById, currentColumnResizeHandles, hoveredDragHandleType, isResizeHandleHovered, shouldCalculateContainerToolbars) => {
  const resizeHandlePositionInfo = [];
  if (shouldCalculateContainerToolbars && currentColumnResizeHandles && targetedDndAreaNodePositionsById && (!hoveredDragHandleType || isResizeHandleHovered)) {
    let parentRow;
    currentColumnResizeHandles.forEach(resizeHandle => {
      const handleType = resizeHandle.type;
      let leftColumn;
      let rightColumn;
      if (handleType === resizeHandleTypes.RESIZE_HANDLE_BETWEEN) {
        leftColumn = targetedDndAreaNodePositionsById[resizeHandle.leftId];
        rightColumn = targetedDndAreaNodePositionsById[resizeHandle.rightId];
        if (leftColumn) {
          parentRow = targetedDndAreaNodePositionsById[leftColumn.parentId];
        }
      } else if (handleType === resizeHandleTypes.RESIZE_HANDLE_LEFT) {
        rightColumn = targetedDndAreaNodePositionsById[resizeHandle.id];
        if (rightColumn) {
          leftColumn = targetedDndAreaNodePositionsById[rightColumn.previousColumnId];
          parentRow = targetedDndAreaNodePositionsById[rightColumn.parentId];
        }
      } else if (handleType === resizeHandleTypes.RESIZE_HANDLE_RIGHT) {
        leftColumn = targetedDndAreaNodePositionsById[resizeHandle.id];
        if (leftColumn) {
          rightColumn = targetedDndAreaNodePositionsById[leftColumn.nextColumnId];
          parentRow = targetedDndAreaNodePositionsById[leftColumn.parentId];
        }
      }
      const positionInfo = getPositionInfoForResizeHandle(leftColumn, rightColumn, parentRow);
      if (positionInfo) {
        positionInfo.type = handleType;
        resizeHandlePositionInfo.push(positionInfo);
      }
    });

    // If we are only showing one left or right handle, check if there are any other
    // handles we should be showing higher up the tree.
    if (resizeHandlePositionInfo.length === 1) {
      const {
        type
      } = resizeHandlePositionInfo[0];
      if (type === resizeHandleTypes.RESIZE_HANDLE_LEFT || type === resizeHandleTypes.RESIZE_HANDLE_RIGHT) {
        const oppositeHandleToShow = type === resizeHandleTypes.RESIZE_HANDLE_LEFT ? resizeHandleTypes.RESIZE_HANDLE_RIGHT : resizeHandleTypes.RESIZE_HANDLE_LEFT;
        // Check to see if parent row of this column has it's own parent column
        if (parentRow && parentRow.parentId) {
          const parentColumn = targetedDndAreaNodePositionsById[parentRow.parentId];
          const grandParentRow = targetedDndAreaNodePositionsById[parentColumn.parentId];
          if (grandParentRow) {
            let leftColumn;
            let rightColumn;
            if (oppositeHandleToShow === resizeHandleTypes.RESIZE_HANDLE_LEFT) {
              leftColumn = targetedDndAreaNodePositionsById[parentColumn.previousColumnId];
              rightColumn = parentColumn;
            } else {
              leftColumn = parentColumn;
              rightColumn = targetedDndAreaNodePositionsById[parentColumn.nextColumnId];
            }
            const positionInfo = getPositionInfoForResizeHandle(leftColumn, rightColumn, grandParentRow);
            if (positionInfo) {
              positionInfo.type = oppositeHandleToShow;
              resizeHandlePositionInfo.push(positionInfo);
            }
          }
        }
      }
    }
  }

  // Always re-use the same exact array for empty resize info, so that we can still use === equality
  // in components to check if anything changed (at least in the basic empty case)
  if (resizeHandlePositionInfo.length === 0) {
    return EMPTY_RESIZE_HANDLE_ARRAY;
  }
  return resizeHandlePositionInfo;
});
const simpleBoundsHash = posInfo => {
  return [posInfo.top, posInfo.left, posInfo.width, posInfo.height].join(',');
};
export const getGridPositions = createSelector(getIsAnythingDragging, getCurrentTopmostRowIdWithDragHandle, getTargetedOrNearbyDndAreaNodePositionsById, getNodePositionsByTreeId, getIsMouseInIFrame, getCurrentDragItem, getTargetedTree, getTargetedGridTree, getCurrentDeepestRowOrColumnIdWithDragHandle, getTargetedDndAreaNodePositionsById, getHoveredSectionId, getSelectedItemPositionInfo, (isAnythingDragging, currentTopmostRowIdWithDragHandle, targetedDndAreaNodePositionsById, nodePositionsByTreeId, isMouseInIFrame, currentDragItem, targetedTree, targetedGridTree, currentDeepestRowOrColumnIdWithDragHandle, targetedNodePositionsById, hoveredSectionId, selectedItemPositionInfo) => {
  const cellOutlinesForGrid = {
    cellPositions: [],
    gutterLinePositions: []
  };
  let rowPositions = [];
  const nodesToGatherParentsFrom = [];

  // Being careful to only use the part of Set that works in IE 11
  const hashedBoundsAlreadyAdded = new Set();
  const addNewCellPosition = (cellId, posInfo, positionsLookup = targetedDndAreaNodePositionsById) => {
    if (!posInfo) {
      posInfo = positionsLookup[cellId];
    }

    // Null check in case the nodePositions haven't yet been updated with the same
    // data as the LayoutTree.
    if (posInfo && posInfo.hasBounds) {
      const boundsHash = simpleBoundsHash(posInfo);

      // Ensure that we prevent duplicate bounds from being added (both when the same ID is added
      // twice _and_ when multiple cells have the same bounds)
      if (!hashedBoundsAlreadyAdded.has(boundsHash)) {
        const newPos = {
          top: posInfo.top,
          left: posInfo.left,
          right: posInfo.right,
          bottom: posInfo.bottom,
          width: posInfo.width,
          height: posInfo.height
        };
        cellOutlinesForGrid.cellPositions.push(newPos);

        // Add the new positions bound hash to the set to compare against other positions
        hashedBoundsAlreadyAdded.add(boundsHash);
      }
    }
  };
  const addNewRowPosition = (rowName, positionsLookup = targetedDndAreaNodePositionsById) => {
    const posInfo = positionsLookup[rowName];

    // Null check in case the nodePositions haven't yet been updated with the same
    // data as the LayoutTree.
    if (posInfo && posInfo.hasBounds) {
      const boundsHash = simpleBoundsHash(posInfo);

      // Ensure that we prevent duplicate bounds from being added (both when the same ID is added
      // twice _and_ when multiple cells have the same bounds)
      if (!hashedBoundsAlreadyAdded.has(boundsHash)) {
        rowPositions.push({
          top: posInfo.top,
          left: posInfo.left,
          right: posInfo.right,
          bottom: posInfo.bottom,
          width: posInfo.width,
          height: posInfo.height
        });

        // Add the new positions bound hash to the set to compare against other positions
        hashedBoundsAlreadyAdded.add(boundsHash);
      }
    }
  };

  // Show grid around selected module if it is in a dnd section
  if (selectedItemPositionInfo && selectedItemPositionInfo.isModule && selectedItemPositionInfo.layoutSectionId) {
    addNewCellPosition(selectedItemPositionInfo.id, null, nodePositionsByTreeId[selectedItemPositionInfo.layoutSectionId]);
  }
  if (isAnythingDragging && targetedTree && hoveredSectionId && currentDragItem) {
    // Show grid lines around all modules and nested rows/cells in the currently hovered section
    if (!currentDragItem.isTopMostRow) {
      targetedTree.allCells({
        fromName: hoveredSectionId
      }).forEach(cell => {
        addNewCellPosition(cell.getName());
      });
      targetedTree.allRows({
        fromName: hoveredSectionId,
        includeStart: true
      }).forEach(row => {
        addNewRowPosition(row.getName());
      });
    } else {
      const root = targetedTree.getRootCell();
      const topLevelRowNames = root.getRowNames();
      topLevelRowNames.forEach(topLevelRowName => {
        addNewRowPosition(topLevelRowName);
      });
    }
  } else if (isAnythingDragging && targetedGridTree && hoveredSectionId && currentDragItem) {
    // Show grid lines around all modules and nested rows/cells in the currently hovered section
    if (!currentDragItem.isTopMostRow) {
      const isDraggingGridCell = !!currentDragItem.layoutNodeType && currentDragItem.isGridCell;
      const sectionNode = targetedGridTree.findSection(hoveredSectionId);
      const draggedNode = currentDragItem.dragId ? targetedGridTree.findNode(currentDragItem.dragId) : null;
      const draggedNodeId = draggedNode === null || draggedNode === void 0 ? void 0 : draggedNode.getId();
      const descendantNodeIds = (draggedNode === null || draggedNode === void 0 ? void 0 : draggedNode.getAllDescendantNodeIds()) || [];
      if (sectionNode.isSection()) {
        iterateFrom(sectionNode, {
          gridNodeCallback: ({
            gridNode
          }) => {
            if (draggedNodeId === gridNode.getId() || descendantNodeIds.includes(gridNode.getId()) || isDraggingGridCell || gridNode.isGridContainerCell()) {
              return;
            } else if (gridNode.isSection()) {
              addNewRowPosition(gridNode.getId());
            } else if (gridNode.isContainer()) {
              if (gridNode.isHorizontalStack()) {
                addNewRowPosition(gridNode.getId());
              } else if (gridNode.isVerticalStack()) {
                addNewCellPosition(gridNode.getId());
              } else if (gridNode.isGrid()) {
                addNewRowPosition(gridNode.getId());
              }
            } else if (gridNode.isModule()) {
              addNewCellPosition(gridNode.getId());
            } else if (gridNode.isRoot()) {
              // Do nothing
            }
          }
        });
      }
    } else {
      const topLevelRowNames = targetedTree.getSectionIds();
      topLevelRowNames.forEach(sectionName => {
        addNewRowPosition(sectionName);
      });
    }
  } else if (isMouseInIFrame) {
    // Grid lines to show when not dragging...
    if (targetedTree && currentTopmostRowIdWithDragHandle && targetedTree.hasRow(currentTopmostRowIdWithDragHandle)) {
      addNewRowPosition(currentTopmostRowIdWithDragHandle, targetedNodePositionsById);
    }
    if (targetedTree && currentDeepestRowOrColumnIdWithDragHandle) {
      // If no handle is hovered, show grid outline around the deepest
      // wrapper row or column
      if (targetedTree.hasCell(currentDeepestRowOrColumnIdWithDragHandle)) {
        nodesToGatherParentsFrom.push(targetedTree.findCell(currentDeepestRowOrColumnIdWithDragHandle).getParentName());
      } else if (targetedTree.hasRow(currentDeepestRowOrColumnIdWithDragHandle)) {
        nodesToGatherParentsFrom.push(targetedTree.findRow(currentDeepestRowOrColumnIdWithDragHandle).getParentName());
      }
      addNewCellPosition(currentDeepestRowOrColumnIdWithDragHandle);
    }
    if (targetedGridTree && currentTopmostRowIdWithDragHandle && targetedGridTree.getSectionIds().some(sectionId => sectionId === currentTopmostRowIdWithDragHandle)) {
      addNewRowPosition(currentTopmostRowIdWithDragHandle, targetedNodePositionsById);
    }
    if (targetedGridTree && currentDeepestRowOrColumnIdWithDragHandle) {
      // If no handle is hovered, show grid outline around the deepest
      // wrapper row or column

      const node = targetedGridTree.findContainer(currentDeepestRowOrColumnIdWithDragHandle);
      nodesToGatherParentsFrom.push(node.getParentNode().getId());
      if (node.isHorizontalStack()) {
        addNewRowPosition(currentDeepestRowOrColumnIdWithDragHandle);
      } else if (node.isVerticalStack()) {
        addNewCellPosition(currentDeepestRowOrColumnIdWithDragHandle);
      }
    }
  }

  // Recursively add parents to the cell and row positions
  while (nodesToGatherParentsFrom.length > 0) {
    const currentNodeName = nodesToGatherParentsFrom.pop();
    let currentNode;
    if (targetedTree) {
      if (targetedTree.hasRow(currentNodeName)) {
        addNewRowPosition(currentNodeName, targetedNodePositionsById);
        currentNode = targetedTree.findRow(currentNodeName);
      } else if (targetedTree.hasCell(currentNodeName)) {
        addNewCellPosition(currentNodeName);
        currentNode = targetedTree.findCell(currentNodeName);
      }
      if (currentNode && currentNode.getParentName() !== targetedTree.getRootName()) {
        nodesToGatherParentsFrom.push(currentNode.getParentName());
      }
    }
    if (targetedGridTree) {
      currentNode = targetedGridTree.findNode(currentNodeName);
      if (currentNode.isSection()) {
        addNewRowPosition(currentNodeName);
      } else if (currentNode.isContainer()) {
        if (currentNode.isHorizontalStack()) {
          addNewRowPosition(currentNodeName);
        } else if (currentNode.isVerticalStack()) {
          addNewCellPosition(currentNodeName);
        } else if (currentNode.isGrid()) {
          addNewRowPosition(currentNodeName);
        }
      }
      const parent = currentNode.getParentNode();
      if (parent.getId() !== targetedGridTree.getRootId()) {
        nodesToGatherParentsFrom.push(parent.getId());
      }
    }
  }

  // Filter out undefined positions from tree updates that don't have any node positions yet
  rowPositions = rowPositions.filter(p => !!p);
  return Object.assign({}, cellOutlinesForGrid, {
    rowPositions
  });
});
export const makeGetEmptyGridContainers = () => createSelector([getAllGridLayoutTreesAsMap, (_, gridLayoutId) => gridLayoutId], (gridLayoutTrees, gridLayoutId) => {
  const gridLayoutTree = gridLayoutTrees[gridLayoutId];
  const emptyContainers = [];
  for (const container of Object.values(gridLayoutTree.getAllContainersById())) {
    if (container.isLeaf()) {
      emptyContainers.push(container);
    }
  }
  return emptyContainers;
});
export const makeGetIsGridLayoutTreeEmpty = () => createSelector([getAllGridLayoutTreesAsMap, (_, gridLayoutId) => gridLayoutId], (gridLayoutTrees, gridLayoutId) => {
  const gridLayoutTree = gridLayoutTrees[gridLayoutId];
  if (!gridLayoutTree) {
    return true;
  }
  return gridLayoutTree.getSectionIds().length === 0;
});
export const getTemporaryOverlays = createLayoutSectionDndSelector('temporaryOverlays');
export const getTemporaryOverlayNodePositions = createSelector(getTemporaryOverlays, getNodePositionsByTreeId, (temporaryOverlays, nodePositionsByTreeId) => {
  const overlayNodePositions = [];
  temporaryOverlays.forEach(overlay => {
    const treeIds = Object.keys(nodePositionsByTreeId);
    for (const treeId of treeIds) {
      const positionsById = nodePositionsByTreeId[treeId];
      const nodePositionForOverlay = positionsById[overlay.rowId];
      if (nodePositionForOverlay) {
        overlayNodePositions.push(nodePositionForOverlay);
        break;
      }
    }
  });
  return overlayNodePositions;
});
export const getScrollToNodePositionTop = createSelector(getScrollToNodePositionId, getNodePositionsByConfigAndId, (scrollToNodeInfo, nodePositions) => {
  const SCROLL_TO_NODE_POSITION_Y_OFFSET = 75;
  if (!scrollToNodeInfo || !nodePositions) {
    return null;
  }
  const nodePositionToScrollTo = findNodePositionForLookupId(nodePositions, scrollToNodeInfo.nodePositionId, scrollToNodeInfo.layoutSectionId);
  if (nodePositionToScrollTo) {
    return nodePositionToScrollTo.top - SCROLL_TO_NODE_POSITION_Y_OFFSET;
  }
  return null;
});
export const getShouldUseCustomSections = createSelector(getIsSectionsEnabled, getHasTheme, (isSectionsEnabled, hasTheme) => isSectionsEnabled && hasTheme);
export const getStaticSectionNodePositionForStaticModuleId = createSelector([getHoveredModuleRowOrColumnInfo, getAllLayoutSectionTreesAsMap, getNodePositionsByConfigAndId], (hoveredNodeInfo, layoutSectionTrees, nodePositionsByConfigAndId) => {
  if (!hoveredNodeInfo) {
    return null;
  }

  // Find which tree contains this static section module
  const treeWithModule = Object.entries(layoutSectionTrees).find(([__, tree]) => tree.hasStaticSectionModule(hoveredNodeInfo.id));
  if (treeWithModule) {
    const [layoutSectionId, tree] = treeWithModule;
    const staticSectionModuleTreeNode = tree.findCell(hoveredNodeInfo.id);
    const parentStaticSectionNodeName = staticSectionModuleTreeNode.getParentName();

    // Look for the parent section in the layout sections config
    const layoutSectionPositions = nodePositionsByConfigAndId[LAYOUT_SECTIONS_CONFIG];
    if (layoutSectionPositions && layoutSectionPositions[layoutSectionId]) {
      const layoutSectionNodePositions = layoutSectionPositions[layoutSectionId];
      return layoutSectionNodePositions[parentStaticSectionNodeName];
    }
  }
  return null;
});